{
	"dialog.ok": "Гаразд",
	"dialog.cancel": "Скасувати",
	"dialog.confirm": "Підтвердити",
	"dialog.close": "Закрити",
	"dialog.import": "Імпортувати",
	"dialog.save": "Зберегти",
	"dialog.discard": "Відкинути",
	"dialog.dontshowagain": "Не показувати знову",
	"data.cube": "Куб",
	"data.group": "Група",
	"data.texture": "Текстура",
	"data.plugin": "Плагін",
	"data.preview": "Перегляд",
	"data.toolbar": "Панель інструментів",
	"data.image": "Зображення",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Пробіл",
	"keys.leftclick": "ЛКМ",
	"keys.middleclick": "СКМ",
	"keys.rightclick": "ПКМ",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Context Menu",
	"keys.left": "Уліво",
	"keys.up": "Угору",
	"keys.right": "Управо",
	"keys.down": "Униз",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "+",
	"keys.comma": ",",
	"keys.point": "Крапка",
	"keys.minus": "-",
	"keys.cross": "+",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "Ліміт обертання",
	"message.rotation_limit.message": "Обертання у Minecraft обмежені однією віссю та у 22.5 градуси. Обертання на іншій осі прибере всі обертання на інших осях. Перетворіть модель на «Типова модель», якщо ви моделюєте для інших цілей і потребуєте вільне обертання.",
	"message.file_not_found.title": "Файл не знайдено",
	"message.file_not_found.message": "Blockbench не зміг знайти файл. Переконайтеся, що він збережений локально, а не в хмарі.",
	"message.screenshot.title": "Знімок екрана",
	"message.screenshot.clipboard": "Буфер обміну",
	"message.screenshot.right_click": "Клацніть ПКМ або довго утримуйте знімок екрана, щоб скопіювати",
	"message.invalid_file.title": "Недійсний файл",
	"message.invalid_file.message": "Не вдалося відкрити файл json: %0",
	"message.invalid_model.title": "Недійсний файл моделі",
	"message.invalid_model.message": "Цей файл не містить дійсних даних моделі.",
	"message.child_model_only.title": "Порожня дочірня модель",
	"message.child_model_only.message": "Це файл дочірньої моделі %0, який не містить моделі.",
	"message.unsaved_textures.title": "Незбережені текстури",
	"message.unsaved_textures.message": "Ваша модель має незбережені текстури. Переконайтеся, що ви зберегли їх і вставили у свій пакет ресурсів у відповідну теку.",
	"message.model_clipping.title": "Модель завелика",
	"message.model_clipping.message": "Ваша модель містить куби (%0), які перевищують ліміт блоків, дозволений Minecraft. Ця модель не буде працювати у Minecraft.",
	"message.loose_texture.title": "Імпорт текстури",
	"message.loose_texture.message": "Імпортована текстура не міститься у пакеті ресурсів. Minecraft може завантажувати текстури лише з теки текстур завантаженого пакета ресурсів.",
	"message.loose_texture.change": "Змінити шлях",
	"message.update_res.title": "Роздільність текстури",
	"message.update_res.message": "Бажаєте оновити роздільність проєкту до роздільності цієї текстури? Натисніть «Скасувати», якщо ваша текстура має вищу роздільність, ніж зазвичай.",
	"message.update_res.update": "Оновити",
	"message.bedrock_overwrite_error.message": "Blockbench не може об’єднати цю модель зі старим файлом",
	"message.bedrock_overwrite_error.backup_overwrite": "Створити копію та перезаписати",
	"message.bedrock_overwrite_error.overwrite": "Перезаписати",
	"message.close_warning.message": "Бажаєте зберегти модель?",
	"message.close_warning.web": "Ваша поточна робота буде втрачена. Ви дійсно бажаєте вийти?",
	"message.default_textures.title": "Усталені текстури",
	"message.default_textures.message": "Виберіть усталену теку «textures» з пакета ресурсів",
	"message.default_textures.detail": "Видобуте усталений пакет ресурсів з файлу .jar або ж загугліть і завантажте його. Потім знайдіть теку «textures» і відкрийте її. Blockbench запам’ятає розташування і спробує узяти текстури звідти, якщо не знайде їх у поточному пакеті ресурсів.",
	"message.default_textures.select": "Виберіть усталену теку «textures»",
	"message.image_editor.title": "Виберіть графічний редактор",
	"message.image_editor.file": "Вибрати файл...",
	"message.image_editor.exe": "Виберіть виконуваний файл графічного редактора",
	"message.display_skin.title": "Скин Minecraft",
	"message.display_skin.message": "Оберіть файл скину з пристрою або введіть ім’я гравця",
	"message.display_skin.upload": "Вибрати файл",
	"message.display_skin.reset": "Скинути",
	"message.invalid_plugin": "Недійсний файл плагіна, див. консоль",
	"message.load_plugin_app": "Бажаєте дозволити цьому плагіну вносити зміни на вашому пристрою? Завантажуйте плагіни лише від авторів, яким ви довіряєте.",
	"message.load_plugin_web": "Бажаєте завантажити цей плагін? Завантажуйте плагіни лише від авторів, яким ви довіряєте.",
	"message.preset_no_info": "Шаблон не містить відомостей для цієї комірки",
	"message.restart_to_update": "Перезапустіть Blockbench, щоб застосувати зміни",
	"message.save_file": "Збережено як %0",
	"dialog.project.title": "Проєкт",
	"dialog.project.name": "Назва файлу",
	"dialog.project.parent": "Батьківська модель",
	"dialog.project.geoname": "Ідентифікатор моделі",
	"dialog.project.ao": "Розсіяне затемнення",
	"dialog.texture.title": "Текстура",
	"dialog.texture.variable": "Змінна",
	"dialog.texture.namespace": "Домен",
	"dialog.texture.folder": "Тека",
	"dialog.extrude.title": "Видавити зображення",
	"dialog.extrude.mode": "Режим сканування",
	"dialog.extrude.mode.areas": "Зони",
	"dialog.extrude.mode.lines": "Лінії",
	"dialog.extrude.mode.columns": "Колони",
	"dialog.extrude.mode.pixels": "Пікселі",
	"dialog.extrude.opacity": "Мін. непрозорість",
	"dialog.extrude.scan": "Сканувати та імпортувати",
	"dialog.display_preset.title": "Створити шаблон",
	"dialog.display_preset.message": "Оберіть комірки, які бажаєте зберегти",
	"dialog.display_preset.create": "Створити",
	"dialog.select.title": "Вибрати",
	"dialog.select.group": "У виділеній групі",
	"dialog.select.name": "Назва містить",
	"dialog.select.random": "Шанс імовірності (%)",
	"dialog.select.select": "Вибрати",
	"dialog.scale.title": "Масштабувати модель",
	"dialog.scale.axis": "Вісь",
	"dialog.scale.clipping": "Обрізання моделі: Ваша модель завелика для полотна",
	"dialog.scale.confirm": "Масштабувати",
	"dialog.plugins.title": "Плагіни",
	"dialog.plugins.installed": "Установлені",
	"dialog.plugins.available": "Доступні",
	"dialog.plugins.install": "Установити",
	"dialog.plugins.uninstall": "Видалити",
	"dialog.plugins.reload": "Перезавантажити",
	"dialog.plugins.none_installed": "Не встановлено жодних плагінів",
	"dialog.plugins.none_available": "Немає доступних плагінів",
	"dialog.plugins.web_only": "Лише для вебзастосунку",
	"dialog.plugins.app_only": "Лише для настільного застосунку",
	"dialog.plugins.author": "від %0",
	"dialog.create_texture.folder": "Тека",
	"dialog.create_texture.resolution": "Роздільність",
	"dialog.input.title": "Введення",
	"dialog.settings.settings": "Налаштування",
	"dialog.settings.keybinds": "Сполучення клавіш",
	"dialog.settings.about": "Про застосунок",
	"layout.color.back": "Назад",
	"layout.color.back.desc": "Тла та рядки введення",
	"layout.color.dark": "Темний",
	"layout.color.dark.desc": "Тло полотна",
	"layout.color.ui": "Інтерфейс",
	"layout.color.ui.desc": "Основний колір інтерфейсу",
	"layout.color.bright_ui": "Яскравий інтерфейс",
	"layout.color.bright_ui.desc": "Контекстні меню та підказки",
	"layout.color.button": "Кнопка",
	"layout.color.button.desc": "Кнопки та перемикачі",
	"layout.color.selected": "Вибрані",
	"layout.color.selected.desc": "Вибрані вкладки та об’єкти",
	"layout.color.border": "Межа",
	"layout.color.border.desc": "Межа кнопок і рядків введення",
	"layout.color.accent": "Акцент",
	"layout.color.accent.desc": "Повзунок великого пальця та інші деталі",
	"layout.color.grid": "Сітка",
	"layout.color.grid.desc": "Сітка 3D перегляду",
	"layout.color.text": "Текст",
	"layout.color.text.desc": "Звичайний текст",
	"layout.color.light": "Підсвітка",
	"layout.color.light.desc": "Виділений текст",
	"layout.color.accent_text": "Акцентний текст",
	"layout.color.accent_text.desc": "Текст на акцентному тлі",
	"layout.font.main": "Основний шрифт",
	"layout.font.headline": "Шрифт заголовків",
	"about.version": "Версія:",
	"settings.category.general": "Загальні",
	"settings.category.preview": "Перегляд",
	"settings.category.grid": "Сітка",
	"settings.category.edit": "Редагування",
	"settings.category.snapping": "Прив’язування",
	"settings.category.defaults": "Усталені параметри",
	"settings.category.dialogs": "Діалогові вікна",
	"settings.category.export": "Експорт",
	"settings.language": "Мова",
	"settings.language.desc": "Мова інтерфейсу",
	"settings.backup_interval": "Інтервал резервного копіювання",
	"settings.backup_interval.desc": "Інтервал автоматичного резервного копіювання у хвилинах",
	"settings.origin_size": "Точка оберту",
	"settings.origin_size.desc": "Розмір точки оберту",
	"settings.control_size": "Розмір інструментів редагування",
	"settings.control_size.desc": "Розмір інструментів для редагування",
	"settings.display_skin": "Скин Minecraft",
	"settings.display_skin.desc": "Скин, використаний для моделі гравця",
	"settings.shading": "Тіні",
	"settings.shading.desc": "Увімкнути тіні у перегляді",
	"settings.base_grid": "Маленька сітка",
	"settings.base_grid.desc": "Показувати маленьку сітку та осі",
	"settings.large_grid": "Велика сітка",
	"settings.large_grid.desc": "Показувати сітку з розміром блоку 16x16",
	"settings.full_grid": "Точна сітка блоків",
	"settings.full_grid.desc": "Показувати сітку блоків з точністю до пікселя",
	"settings.large_box": "Велика коробка",
	"settings.large_box.desc": "Показувати межу блоків у кубі 3x3x3",
	"settings.display_grid": "Сітка у режимі показу",
	"settings.display_grid.desc": "Показати сітку в режимі показу",
	"settings.undo_limit": "Обмеження скасованих дій",
	"settings.undo_limit.desc": "Кількість скасувань дій, які можна скасувати",
	"settings.local_move": "Перемістити на відносні осі",
	"settings.local_move.desc": "По можливості переміщати обертані елементи на їх власних осях",
	"settings.canvas_unselect": "Знімати виділення при натисканні на тло",
	"settings.canvas_unselect.desc": "Знімає виділення з усіх елементів при натисканні на тло за моделлю або на часовій шкалі",
	"settings.paint_side_restrict": "Обмежити пензель на сторону",
	"settings.paint_side_restrict.desc": "Обмежити пензлі для фарбування лише поточної сторони",
	"settings.autouv": "Авто. UV",
	"settings.autouv.desc": "Увімкнути автоматичний UV усталено",
	"settings.create_rename": "Перейменовувати новий елемент",
	"settings.create_rename.desc": "Сфокусувати на поле назви при створенні нового елемента або групи",
	"settings.edit_size": "Роздільність сітки",
	"settings.edit_size.desc": "Роздільність сітки, до якої прив’язуються елементи",
	"settings.shift_size": "Роздільність Shift",
	"settings.shift_size.desc": "Роздільність сітки при утриманні Shift",
	"settings.ctrl_size": "Роздільність Control",
	"settings.ctrl_size.desc": "Роздільність сітки при утриманні Control",
	"settings.negative_size": "Від’ємний розмір",
	"settings.negative_size.desc": "Дозволити інструменту зміни розміру використовувати від’ємні розміри",
	"settings.minifiedout": "Мінімізований експорт",
	"settings.minifiedout.desc": "Записувати JSON файли в один рядок",
	"settings.export_groups": "Експорт груп у моделях блоків/предметів Java",
	"settings.export_groups.desc": "Зберігати групи у файлах JSON моделі блоку чи предмета Java",
	"settings.credit": "Коментар автора",
	"settings.credit.desc": "Додати коментар автора до експортованих файлів",
	"settings.default_path": "Усталений шлях до текстур Minecraft",
	"settings.default_path.desc": "Тека, звідки Blockbench завантажує усталені текстури",
	"settings.image_editor": "Графічний редактор",
	"settings.image_editor.desc": "Усталений графічний редактор для текстур",
	"category.navigate": "Навігація",
	"category.tools": "Інструменти",
	"category.file": "Файл",
	"category.blockbench": "Blockbench",
	"category.edit": "Редагувати",
	"category.transform": "Трансформація",
	"category.view": "Вигляд",
	"category.display": "Налаштування показу",
	"category.textures": "Текстури",
	"category.misc": "Різне",
	"keybind.preview_select": "Виділити",
	"keybind.preview_rotate": "Обернути вид",
	"keybind.preview_drag": "Перетягнути вид",
	"keybind.confirm": "Підтвердити",
	"keybind.cancel": "Скасувати",
	"action.slider_inflate": "Роздути",
	"action.slider_inflate.desc": "Роздути куб у всіх напрямках, не змінюючи UV",
	"action.slider_brush_size": "Розмір",
	"action.slider_brush_size.desc": "Радіус пензля в пікселях",
	"action.slider_brush_opacity": "Непрозорість",
	"action.slider_brush_opacity.desc": "Непрозорість пензля від 0 до 255",
	"action.slider_brush_softness": "М’якість",
	"action.slider_brush_softness.desc": "М’якість пензля у відсотках",
	"action.uv_slider_pos_x": "Перемістити горизонтально",
	"action.uv_slider_pos_x.desc": "Перемістити виділені UV грані горизонтально",
	"action.uv_slider_pos_y": "Перемістити вертикально",
	"action.uv_slider_pos_y.desc": "Перемістити виділені UV грані вертикально",
	"action.uv_slider_size_x": "Масштабувати горизонтально",
	"action.uv_slider_size_x.desc": "Змінити розмір усіх виділених UV грань горизонтально",
	"action.uv_slider_size_y": "Розмір по вертикалі",
	"action.uv_slider_size_y.desc": "Змінити розмір усіх виділених UV грань вертикально",
	"action.vertex_snap_mode": "Режим прив’язки",
	"action.vertex_snap_mode.desc": "Оберіть, якщо «Прив’язати вершину» переміщує елементи у вибрану позицію чи змінює їх розмір",
	"action.move_tool": "Перемістити",
	"action.move_tool.desc": "Інструмент для виділення та переміщення елементів",
	"action.resize_tool": "Змінити розмір",
	"action.resize_tool.desc": "Інструмент для виділення та зміни розміру елементів",
	"action.brush_tool": "Пензель",
	"action.brush_tool.desc": "Пензель для малювання текстур",
	"action.vertex_snap_tool": "Прив’язати вершину",
	"action.vertex_snap_tool.desc": "Перемістити один куб до іншого, з’єднавши дві вершини",
	"action.swap_tools": "Змінити інструмент",
	"action.swap_tools.desc": "Перемикання між інструментом переміщення та зміни розміру",
	"action.project_window": "Проєкт...",
	"action.project_window.desc": "Відкриває вікно проєкту, де можна редагувати метадані моделі",
	"action.open_model": "Відкрити модель",
	"action.open_model.desc": "Відкрити файл моделі з пристрою",
	"action.extrude_texture": "Розтягнути текстуру",
	"action.extrude_texture.desc": "Створити модель, розтягнувши текстуру",
	"action.export_blockmodel": "Експортувати моделю блоку/предмета",
	"action.export_blockmodel.desc": "Експортувати модель блоку/предмета Minecraft Java Edition",
	"action.export_optifine_part": "Експортувати частину OptiFine",
	"action.export_optifine_part.desc": "Експортувати одну частину для моделі сутності OptiFine",
	"action.export_optifine_full": "Експортувати OptiFine JEM",
	"action.export_optifine_full.desc": "Експортувати повну модель сутності OptiFine",
	"action.export_obj": "Експортувати модель OBJ",
	"action.export_obj.desc": "Експортувати модель Wavefront OBJ для візуалізації",
	"action.settings_window": "Налаштування...",
	"action.settings_window.desc": "Відкрити вікно налаштувань Blockbench.",
	"action.plugins_window": "Плагіни...",
	"action.plugins_window.desc": "Відкрити вікно крамниці плагінів.",
	"action.reset_layout": "Скинути макет",
	"action.reset_layout.desc": "Відновити усталений макет Blockbench",
	"action.load_plugin": "Завантажити плагін з файлу",
	"action.load_plugin.desc": "Завантажити плагін, імпортувавши вихідний файл",
	"action.reload_plugins": "Перезавантажити плагіни",
	"action.reload_plugins.desc": "Перезавантажити всі плагіни розробки",
	"action.undo": "Скасувати",
	"action.undo.desc": "Скасовує останню зміну",
	"action.redo": "Відновити",
	"action.redo.desc": "Відновлює останню зміну",
	"action.copy": "Копіювати",
	"action.copy.desc": "Копіювати виділення, виділену грань або параметри показу",
	"action.paste": "Вставити",
	"action.paste.desc": "Вставити виділення, виділену грань або параметри показу",
	"action.cut": "Вирізати",
	"action.cut.desc": "Вирізати виділення, виділену грань або параметри показу",
	"action.add_cube": "Додати куб",
	"action.add_cube.desc": "Додає новий куб",
	"action.add_group": "Додати групу",
	"action.add_group.desc": "Додає нову групу або кістку",
	"action.outliner_toggle": "Більше параметрів",
	"action.outliner_toggle.desc": "Показує/ховає додаткові параметри елементів у планувальнику",
	"action.duplicate": "Дублікат",
	"action.delete": "Видалити",
	"action.sort_outliner": "Упорядкувати планувальник",
	"action.sort_outliner.desc": "Упорядкувати планувальник за алфавітом",
	"action.select_window": "Вибрати...",
	"action.select_window.desc": "Пошук і вибір елементів на основі їхніх властивостей",
	"action.invert_selection": "Інвертувати виділення",
	"action.invert_selection.desc": "Інвертувати поточні виділені елементи",
	"action.select_all": "Виділити все",
	"action.collapse_groups": "Згорнути групи",
	"action.collapse_groups.desc": "Згорнути всі групи у планувальнику",
	"action.scale": "Масштабувати...",
	"action.scale.desc": "Масштабувати вибрані елементи",
	"action.toggle_visibility": "Перемикнути видимість",
	"action.toggle_visibility.desc": "Перемикнути видимість вибраних елементів",
	"action.toggle_export": "Перемикнути експорт",
	"action.toggle_export.desc": "Перемикнути налаштуваня експорту вибраних елементів",
	"action.toggle_autouv": "Перемикнути авто. UV",
	"action.toggle_autouv.desc": "Перемикнути налаштування авто. UV вибраних елементів",
	"action.toggle_shade": "Перемикнути тіні",
	"action.toggle_shade.desc": "Перемикнути видимість тіні виділених кубів",
	"action.rename": "Перейменувати",
	"action.rename.desc": "Перейменувати виділені елементи або групи",
	"action.add_display_preset": "Новий шаблон",
	"action.add_display_preset.desc": "Додати новий шаблон налаштувань показу",
	"action.fullscreen": "На весь екран",
	"action.fullscreen.desc": "Перемикнути на весь екран",
	"action.zoom_in": "Збільшити",
	"action.zoom_in.desc": "Збільшити масштаб інтерфейсу",
	"action.zoom_out": "Зменшити",
	"action.zoom_out.desc": "Зменшити масштаб інтерфейсу",
	"action.zoom_reset": "Скинути масштаб",
	"action.zoom_reset.desc": "Відновити усталений масштаб до 100%",
	"action.reset_interface": "Скинути інтерфейс",
	"action.reset_interface.desc": "Скинути розмір та позиції елементів інтерфейсу",
	"action.screenshot_model": "Зробити знімок моделі",
	"action.screenshot_model.desc": "Зробити обрізаний знімок моделі з поточного ракурсу",
	"action.screenshot_app": "Зробити знімок програми",
	"action.screenshot_app.desc": "Зробити знімок усієї програми",
	"action.import_texture": "Імпортувати текстуру",
	"action.import_texture.desc": "Імпортувати текстуру з системи",
	"action.create_texture": "Створити текстуру",
	"action.create_texture.desc": "Створити порожню текстуру або шаблон текстури",
	"action.save_textures": "Зберегти текстури",
	"action.save_textures.desc": "Зберегти всі незбережені текстури",
	"action.animated_textures": "Відтворити анімовані текстури",
	"action.animated_textures.desc": "Відтворити/зупинити перегляд анімованих текстур",
	"action.origin_to_geometry": "Центр точки оберту",
	"action.origin_to_geometry.desc": "Установити центр точки оберту в центр виділення",
	"action.bone_reset_toggle": "Скинути кістку",
	"action.bone_reset_toggle.desc": "Зупинити показ кісткою кубів із батьківської моделі",
	"action.reload": "Перезавантажити Blockbench",
	"action.reload.desc": "Перезавантажити Blockbench. Це призведе до втрати незбереженого прогресу",
	"menu.file": "Файл",
	"menu.edit": "Редагувати",
	"menu.transform": "Трансформація",
	"menu.display": "Показ",
	"menu.view": "Вигляд",
	"menu.file.new": "Новий",
	"menu.file.recent": "Недавні",
	"menu.file.import": "Імпортувати",
	"menu.file.export": "Експортувати",
	"menu.transform.rotate": "Повернути",
	"menu.transform.flip": "Перевернути",
	"menu.transform.center": "Відцентрувати",
	"menu.transform.properties": "Властивості",
	"menu.display.preset": "Застосувати шаблон",
	"menu.display.preset_all": "Застосувати шаблон усюди",
	"menu.display.remove_preset": "Видалити шаблон",
	"menu.view.zoom": "Масштаб",
	"menu.view.background": "Тло",
	"menu.view.screenshot": "Знімок екрана",
	"menu.cube.color": "Колір позначки",
	"menu.cube.texture": "Текстура",
	"menu.cube.texture.transparent": "Прозора",
	"menu.cube.texture.blank": "Порожня",
	"menu.group.sort": "Упорядкувати",
	"menu.texture.face": "Застосувати до грані",
	"menu.texture.file": "Файл",
	"menu.texture.refresh": "Оновити",
	"menu.texture.change": "Змінити файл",
	"menu.texture.folder": "Показати у провіднику файлів",
	"menu.texture.edit": "Редагувати",
	"menu.texture.export": "Зберегти як",
	"menu.texture.save": "Зберегти",
	"menu.texture.properties": "Властивості...",
	"menu.preview.background": "Тло",
	"menu.preview.background.load": "Завантажити",
	"menu.preview.background.position": "Позиція",
	"menu.preview.background.lock": "Зафіксувати до камери",
	"menu.preview.screenshot": "Знімок екрана",
	"menu.preview.perspective": "Перспектива",
	"menu.preview.perspective.normal": "Звичайна",
	"menu.preview.quadview": "Чотирикутний вид",
	"menu.preview.stop_drag": "Зупинити фонове позиціювання",
	"menu.uv.mapping.rotation": "Обертання",
	"menu.uv.texture": "Текстура",
	"cube.color.light_blue": "Блакитний",
	"cube.color.yellow": "Жовтий",
	"cube.color.orange": "Помаранчевий",
	"cube.color.red": "Червоний",
	"cube.color.purple": "Фіолетовий",
	"cube.color.blue": "Синій",
	"cube.color.green": "Зелений",
	"cube.color.lime": "Лаймовий",
	"switches.visibility": "Видимість",
	"switches.export": "Експортувати",
	"switches.autouv": "Авто. UV",
	"panel.uv": "UV",
	"panel.display": "Показ",
	"panel.textures": "Текстури",
	"panel.outliner": "Планувальник",
	"uv_editor.title": "Редактор UV",
	"uv_editor.all_faces": "Усі",
	"uv_editor.no_faces": "Ніякі",
	"face.north": "Північ",
	"face.south": "Південь",
	"face.west": "Захід",
	"face.east": "Схід",
	"face.up": "Верх",
	"face.down": "Низ",
	"direction.north": "Північ",
	"direction.south": "Південь",
	"direction.west": "Захід",
	"direction.east": "Схід",
	"direction.top": "Верх",
	"direction.bottom": "Низ",
	"display.slot.third_right": "Праворуч від третьої особи",
	"display.slot.third_left": "Ліворуч від третьої особи",
	"display.slot.first_right": "Праворуч від першої особи",
	"display.slot.first_left": "Ліворуч від першої особи",
	"display.slot.head": "Голова",
	"display.slot.ground": "Земля",
	"display.slot.frame": "Рамка",
	"display.slot.gui": "Інтерфейс",
	"display.rotation": "Обертання",
	"display.translation": "Переміщення",
	"display.scale": "Розмір",
	"display.slot": "Слот",
	"display.reference": "Еталонна модель",
	"display.reference.player": "Гравець",
	"display.reference.zombie": "Зомбі",
	"display.reference.armor_stand": "Стійка для обладунків",
	"display.reference.baby_zombie": "Зомбі-немовля",
	"display.reference.armor_stand_small": "Маленька стійка для обладунків",
	"display.reference.monitor": "Звичайний",
	"display.reference.bow": "Заряджений лук",
	"display.reference.block": "Блок",
	"display.reference.frame": "Рамка",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Інвентар",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Будь ласка, введіть назву",
	"display.preset.item": "Усталений предмет",
	"display.preset.block": "Усталений блок",
	"display.preset.handheld": "Усталена зброя",
	"display.preset.rod": "Усталена вудка",
	"dialog.continue": "Продовжити",
	"message.square_textures": "Текстури повинні бути квадратними",
	"message.unsaved_texture.title": "Незбережена текстура",
	"message.unsaved_texture.message": "Усі незбережені зміни до цієї текстури буде втрачено. Бажаєте продовжити?",
	"action.vertex_snap_mode.move": "Перемістити",
	"action.vertex_snap_mode.scale": "Масштабувати",
	"action.open_model_folder": "Відкрити теку моделі",
	"action.open_model_folder.desc": "Відкриває теку, у якій міститься модель",
	"action.change_textures_folder": "Змінити розташування текстури",
	"action.change_textures_folder.desc": "Змінити теку, до якої зберігаються всі текстури",
	"menu.texture.particle": "Використовувати для частинок",
	"message.update_notification.title": "Не вдалося встановити оновлення",
	"message.update_notification.message": "Доступна нова версія Blockbench. Будь ласка, увімкніть автоматичне оновлення в налаштуваннях, щоб оновити версію!",
	"message.untextured": "Ця поверхня не має текстури",
	"dialog.toolbar_edit.title": "Налаштувати панель інструментів",
	"keybindings.reset": "Скинути",
	"keybindings.clear": "Немає",
	"action.cube_counter": "Показники моделі",
	"action.uv_rotation": "Обертання UV",
	"action.uv_rotation.desc": "Обертання UV грані",
	"action.uv_grid": "Сітка UV",
	"action.uv_grid.desc": "Роздільність сітки, до якої прив’язується UV",
	"action.uv_grid.auto": "Авто.",
	"action.uv_maximize": "Розгорнути UV",
	"action.uv_maximize.desc": "Задає UV для цієї грані на повну текстуру",
	"action.uv_auto": "Авто. UV",
	"action.uv_auto.desc": "Задає розмір UV цієї грані до реального розміру грані",
	"action.uv_rel_auto": "Відносне авто. UV",
	"action.uv_rel_auto.desc": "Задає UV цієї грані відповідно до позиції та розміру реальної грані",
	"action.uv_mirror_x": "Віддзеркалити UV по X",
	"action.uv_mirror_x.desc": "Віддзеркалити UV цієї грані по осі X",
	"action.uv_mirror_y": "Віддзеркалити UV по Y",
	"action.uv_mirror_y.desc": "Віддзеркалити UV цієї грані по осі Y",
	"action.uv_transparent": "Вилучити грань",
	"action.uv_transparent.desc": "Вилучити поточну грань",
	"action.uv_reset": "Скинути грань",
	"action.uv_reset.desc": "Скинути поточну грань",
	"action.cullface": "Відсікання грані",
	"action.cullface.desc": "Вимикає візуалізацію для цієї грані, якщо вибрана грань моделі прикрита",
	"action.auto_cullface": "Увімкнути відсікання грані",
	"action.auto_cullface.desc": "Умикає відсікання для цієї грані до себе",
	"action.face_tint": "Тіні",
	"action.face_tint.desc": "Умикає тіні для поточної грані",
	"menu.toolbar.edit": "Налаштувати панель інструментів",
	"menu.toolbar.reset": "Скинути панель інструментів",
	"uv_editor.rotated": "Обернуто",
	"uv_editor.auto_cull": "Відсікання грані до себе",
	"uv_editor.copied": "Грань скопійовано",
	"uv_editor.pasted": "Грань вставлено",
	"uv_editor.copied_x": "Скопійовано грань: %0",
	"uv_editor.reset": "Скинути грань",
	"uv_editor.maximized": "Розгорнуто",
	"uv_editor.autouv": "Авто. розмір",
	"uv_editor.mirrored": "Віддзеркалено",
	"uv_editor.to_all": "Застосовано до всіх грань",
	"uv_editor.transparent": "Зроблено прозорою",
	"uv_editor.cullface_on": "Відсікання грані: увімк.",
	"uv_editor.cullface_off": "Відсікання грані: вимк.",
	"uv_editor.tint_on": "Тіні ввімкнено",
	"uv_editor.tint_off": "Тіні вимкнено",
	"action.uv_apply_all": "Застосувати до всіх грань",
	"action.uv_apply_all.desc": "Застосовує налаштування поточної грані до всіх грань",
	"message.image_editor_missing.title": "Усталений графічний редактор",
	"message.image_editor_missing.message": "Оберіть виконуваний файл графічного редактора.",
	"message.image_editor_missing.detail": "Blockbench не зміг знайти графічний редактор на пристрої. Оберіть виконуваний файл бажаного графічного редактора.",
	"action.update_autouv": "Оновити авто. UV",
	"action.update_autouv.desc": "Оновити авто. UV мапування виділених кубів",
	"category.uv": "UV",
	"status_bar.saved": "Модель збережено",
	"status_bar.unsaved": "Є незбережені зміни",
	"action.move_up": "Перемістити вгору",
	"action.move_up.desc": "Перемістити виділені елементи вгору відносно поточного ракурсу камери",
	"action.move_down": "Перемістити вниз",
	"action.move_down.desc": "Перемістити виділені елементи вниз відносно поточного ракурсу камери",
	"action.move_left": "Перемістити вліво",
	"action.move_left.desc": "Перемістити виділені елементи вліво відносно поточного ракурсу камери",
	"action.move_right": "Перемістити вправо",
	"action.move_right.desc": "Перемістити виділені елементи вправо відносно поточного ракурсу камери",
	"action.move_forth": "Перемістити вперед",
	"action.move_forth.desc": "Перемістити виділені елементи вперед відносно поточного ракурсу камери",
	"action.move_back": "Перемістити назад",
	"action.move_back.desc": "Перемістити виділені елементи назад відносно поточного ракурсу камери",
	"layout.color.wireframe": "Каркас",
	"layout.color.wireframe.desc": "Лінії каркасного виду",
	"action.add_animation": "Додати анімацію",
	"action.add_animation.desc": "Створити анімацію",
	"action.load_animation_file": "Імпортувати анімації",
	"action.load_animation_file.desc": "Імпортувати файл анімації",
	"action.play_animation": "Відтворити анімацію",
	"action.play_animation.desc": "Проглянути вибрану анімацію",
	"action.slider_keyframe_time": "Тайм-код",
	"action.slider_keyframe_time.desc": "Змінити тайм-код вибраних кадрів",
	"timeline.rotation": "Обертати",
	"timeline.position": "Позиція",
	"timeline.scale": "Масштабувати",
	"menu.keyframe.quaternion": "Кватерніон",
	"panel.animations": "Анімації",
	"panel.keyframe": "Кадр",
	"panel.keyframe.type": "Кадр (%0)",
	"generic.delete": "Видалити",
	"generic.rename": "Перейменувати",
	"message.no_animation_selected": "Для цього потрібно вибрати анімацію",
	"message.no_bone_selected": "Для цього потрібно вибрати кістку",
	"message.duplicate_groups.title": "Дублікат назви кістки",
	"message.duplicate_groups.message": "Назва цієї кістки вже існує у кількох кістках. Це може спричинити проблеми.",
	"action.delete_keyframes": "Видалити кадри",
	"action.delete_keyframes.desc": "Видалити виділені кадри",
	"menu.animation": "Анімація",
	"menu.animation.loop": "Режим циклу",
	"menu.animation.override": "Перезаписати",
	"menu.animation.anim_time_update": "Оновлення часу анімації",
	"message.display_skin_model.title": "Модель скина",
	"message.display_skin_model.message": "Оберіть тип моделі скина",
	"message.display_skin_model.classic": "Класичний",
	"message.display_skin_model.slim": "Стрункий",
	"message.bone_material": "Змінити матеріал кістки",
	"action.slider_animation_length": "Довжина анімації",
	"action.slider_animation_length.desc": "Змінити довжину вибраної анімації",
	"panel.variable_placeholders": "Заповнювачі змінних",
	"panel.variable_placeholders.info": "Перелічіть змінні, які бажаєте проглянути через name=value",
	"status_bar.vertex_distance": "Відстань: %0",
	"dialog.create_gif.title": "Запис GIF",
	"dialog.create_gif.length": "Довжина",
	"dialog.create_gif.fps": "Кадри/c",
	"dialog.create_gif.play": "Відтворити анімацію",
	"category.animation": "Анімація",
	"action.record_model_gif": "Запис GIF...",
	"action.record_model_gif.desc": "Записати анімоване GIF зображення моделі з поточного ракурсу",
	"display.mirror": "Дзеркало",
	"data.separator": "Роздільник",
	"menu.preview.background.set_position": "Установити позицію",
	"dialog.toolbar_edit.hidden": "Приховано",
	"action.export_class_entity": "Експортувати сутність Java",
	"action.export_class_entity.desc": "Експортувати модель сутності як клас Java",
	"settings.seethrough_outline": "Рентгенівські контури",
	"settings.seethrough_outline.desc": "Показувати контури через об’єкти",
	"mode.edit": "Редагувати",
	"mode.paint": "Малювати",
	"mode.display": "Показ",
	"mode.animate": "Анімувати",
	"status_bar.recording_gif": "Записування",
	"status_bar.processing_gif": "Оброблення",
	"settings.backup_retain": "Тривалість збереження резервної копії",
	"settings.backup_retain.desc": "Визначити, як довго Blockbench зберігає старі резервні копії у днях",
	"action.rotate_tool": "Обертати",
	"action.rotate_tool.desc": "Інструмент для виділення та обертання елементів",
	"action.fill_tool": "Заливка",
	"action.fill_tool.desc": "Відро для заливки всієї грані одним кольором",
	"action.eraser": "Гумка",
	"action.eraser.desc": "Інструмент для заміни кольорів на текстурі з прозорістю",
	"action.color_picker": "Піпетка",
	"action.color_picker.desc": "Інструмент для вибору кольору пікселів текстури",
	"switches.mirror": "Віддзеркалити UV",
	"language_name": "Українська",
	"message.plugin_reload": "Перезавантажено локальні плагіни (%0)",
	"settings.brightness": "Яскравість",
	"settings.brightness.desc": "Яскравість перегляду моделі. Усталене значення — 50",
	"menu.preview.perspective.reset": "Скинути камеру",
	"action.fill_mode": "Режим заповнення",
	"action.fill_mode.face": "Грань",
	"action.fill_mode.color": "Кольори",
	"action.toggle_mirror_uv": "Віддзеркалити UV",
	"action.toggle_mirror_uv.desc": "Перемикнути UV віддзеркалення на осі X виділених кубів",
	"menu.texture.blank": "Застосувати до грань без текстур",
	"dialog.scale.select_overflow": "Оберіть переповнення",
	"action.action_control": "Контроль дій",
	"action.action_control.desc": "Шукати та виконати будь-яку доступну дію",
	"keybindings.recording": "Сполучення клавіш для запису",
	"keybindings.press": "Натисніть клавішу або комбінацію клавіш чи клацніть будь-де на екрані, щоб записати сполучення клавіш.",
	"action.pivot_tool": "Точка оберту",
	"action.pivot_tool.desc": "Інструмент для зміни точки оберту елементів і кісток",
	"action.slider_animation_speed": "Швидкість відтворення",
	"action.slider_animation_speed.desc": "Швидкість відтворення часової шкали у відсотках",
	"action.previous_keyframe": "Попередній кадр",
	"action.previous_keyframe.desc": "Перейти до попереднього кадру",
	"action.next_keyframe": "Наступний кадр",
	"action.next_keyframe.desc": "Перейти до наступного кадру",
	"message.outdated_client.title": "Застарілий клієнт",
	"message.outdated_client.message": "Для цього оновіть Blockbench до останньої версії.",
	"action.export_asset_archive": "Завантажити архів",
	"action.export_asset_archive.desc": "Завантажити архів з моделлю і всіма текстурами в ній",
	"action.upload_sketchfab": "Вивантажити в Sketchfab...",
	"message.sketchfab.name_or_token": "Будь ласка, введіть свій токен Sketchfab та ім’я",
	"dialog.sketchfab_uploader.title": "Вивантажити модель в Sketchfab",
	"dialog.sketchfab_uploader.token": "Токен API",
	"dialog.sketchfab_uploader.about_token": "Токен використовується для підключення Blockbench до вашого обл. запису Sketchfab. Ви можете знайти його на %0",
	"dialog.sketchfab_uploader.name": "Назва моделі",
	"dialog.sketchfab_uploader.description": "Опис",
	"dialog.sketchfab_uploader.tags": "Теги",
	"settings.sketchfab_token": "Токен Sketchfab",
	"settings.sketchfab_token.desc": "Токен для авторизації вивантаження з Blockbench до вашого облікового запису Sketchfab",
	"panel.color": "Колір",
	"data.origin": "Точка оберту",
	"message.sketchfab.success": "Модель успішно вивантажено",
	"message.sketchfab.error": "Не вдалося вивантажити модель в Sketchfab",
	"settings.outliner_colors": "Кольори в планувальнику",
	"settings.outliner_colors.desc": "Показувати кольори елементів і груп у планувальнику",
	"action.upload_sketchfab.desc": "Вивантажити модель у Sketchfab",
	"action.element_colors": "Кольори кубів",
	"action.element_colors.desc": "Показувати кольори кубів у планувальнику",
	"texture.error.file": "Файл не знайдено",
	"texture.error.parent": "Файл текстури, наданий батьківською моделлю",
	"message.recover_backup.title": "Відновлення моделей",
	"message.recover_backup.message": "Blockbench було закрито без збереження. Бажаєте відновити моделі?",
	"message.invalid_session.title": "Недійсний токен сесії",
	"message.invalid_session.message": "Сесія, до якої ви намагаєтеся приєднатися, закінчилася, або надано недійсний токен.",
	"dialog.create_texture.power": "Розмір у степені двійки",
	"dialog.create_gif.turn": "Швидкість відтворення",
	"action.edit_session": "Сесія редагування...",
	"action.edit_session.desc": "Підключіться до сесії редагування, щоб співпрацювати з іншими користувачами",
	"action.reset_keyframe": "Скинути кадр",
	"action.reset_keyframe.desc": "Скинути значення усіх виділених кадрів",
	"dialog.edit_session.title": "Сесія редагування",
	"edit_session.username": "Ім’я користувача",
	"edit_session.token": "Токен",
	"edit_session.about": "Сесії редагування можна використовувати для спільної роботи над моделями в Інтернеті. Створіть сесію, скопіюйте токен і надішліть його друзям, які зможуть долучитися до неї.",
	"edit_session.join": "Долучитися до сесії",
	"edit_session.create": "Створити сесію",
	"edit_session.quit": "Вийти з сесії",
	"edit_session.joined": "%0 долучається до сесії",
	"edit_session.left": "%0 покидає сесію",
	"edit_session.quit_session": "Покинули поточну сесію",
	"edit_session.status": "Стан",
	"edit_session.hosting": "Хостинг",
	"edit_session.connected": "Підключилися до сесії",
	"dialog.sketchfab_uploader.private": "Приватний (Pro)",
	"dialog.sketchfab_uploader.password": "Пароль (Pro)",
	"action.uv_select_all": "Виділити всі",
	"action.uv_select_all.desc": "Виділити всі грані у діалоговому вікні UV",
	"panel.chat": "Чат",
	"edit_session.welcome": "Ласкаво просимо до сесії від %0",
	"dialog.yes": "Так",
	"dialog.no": "Ні",
	"generic.remove": "Видалити",
	"generic.download": "Завантажити",
	"generic.search": "Пошук",
	"dates.today": "Сьогодні",
	"dates.yesterday": "Учора",
	"dates.this_week": "Цього тижня",
	"dates.weeks_ago": "%0 тижн. тому",
	"mode.start.new": "Створити",
	"mode.start.recent": "Недавні",
	"format.free": "Типова модель",
	"format.free.desc": "Модель без обмежень. Для ігрових рушіїв, візуалізації тощо.",
	"format.java_block": "Блок/предмет Java",
	"format.java_block.desc": "Модель блоку або предмета для Minecraft Java Edition.",
	"format.bedrock": "Сутність Bedrock",
	"format.bedrock.desc": "Модель Minecraft Bedrock Edition для сутностей та предметів",
	"format.bedrock_old": "Усталена модель Bedrock",
	"format.bedrock_old.desc": "Модель сутностей до версії Minecraft Bedrock Edition 1.12",
	"format.modded_entity": "Модифікована сутність",
	"format.modded_entity.desc": "Модель сутності для модів Minecraft. Може бути експортована у вигляді файлів класів .java.",
	"format.optifine_entity": "Сутність OptiFine",
	"format.optifine_entity.desc": "Користувацька модель сутності для мода OptiFine",
	"keys.mouse": "Кнопка миші %0",
	"message.cleared_blank_faces.title": "Порожні грані",
	"message.cleared_blank_faces.message": "Blockbench знайшов куби (%0) без текстур. Бажаєте видалити ці елементи?",
	"message.wireframe.enabled": "Каркасний вид увімкнено",
	"message.wireframe.disabled": "Каркасний вид вимкнено",
	"dialog.convert_project.title": "Перетворити проєкт",
	"dialog.create_texture.double_use": "Зберігати заповненість кількох текстур",
	"dialog.model_stats.title": "Показники моделі",
	"dialog.model_stats.cubes": "Куби",
	"dialog.model_stats.locators": "Локатори",
	"dialog.model_stats.groups": "Групи",
	"dialog.model_stats.vertices": "Вершини",
	"dialog.model_stats.faces": "Грані",
	"settings.username": "Ім’я користувача",
	"settings.username.desc": "Ім’я користувача для сесій редагування",
	"settings.painting_grid": "Сітка малювання",
	"settings.painting_grid.desc": "Показувати сітку на елементах з текстурами у режимі малювання",
	"action.convert_project": "Перетворити проєкт",
	"action.convert_project.desc": "Перетворити поточний проєкт на проєкт для іншого формату моделі",
	"action.close_project": "Закрити проєкт",
	"action.close_project.desc": "Закрити відкритий проєкт",
	"action.export_bedrock": "Експортувати геометрію Bedrock",
	"action.export_bedrock.desc": "Експортувати модель як файл геометрії Bedrock Edition.",
	"action.save_project": "Зберегти проєкт",
	"action.save_project.desc": "Зберегти поточну модель як файл проєкту",
	"action.save_project_as": "Зберегти проєкт як",
	"action.save_project_as.desc": "Зберегти поточну модель як файл проєкту в новому місці",
	"action.export_over": "Зберегти модель",
	"action.export_over.desc": "Зберегти модель, текстури та анімації, перезаписуючи файли",
	"action.add_locator": "Додати локатор",
	"action.add_locator.desc": "Додати новий локатор для контролю положення частинок, повідців тощо",
	"action.uv_turn_mapping": "Обернути мапування",
	"action.uv_turn_mapping.desc": "Обернути UV мапування на 90 градусів",
	"action.remove_blank_faces": "Вилучити порожні грані",
	"action.remove_blank_faces.desc": "Видаляє усі грані без текстур виділення",
	"web.download_app": "Завантажити застосунок",
	"uv_editor.turned": "Мапування обернено",
	"display.reference.crossbow": "Заряджений арбалет",
	"dialog.settings.search_results": "Результати пошуку",
	"settings.animation_snap": "Прив’язка анімації",
	"settings.animation_snap.desc": "Типовий інтервал прив’язки на часовій шкалі анімації у кроках на секунду. Цей параметр також можна змінити для кожної анімації. Усталене значення — 24.",
	"action.import_optifine_part": "Імпортувати частину OptiFine",
	"action.import_optifine_part.desc": "Імпортувати модель частини сутності для OptiFine",
	"data.locator": "Локатор",
	"mode.start.no_recents": "Немає недавно відкритих моделей",
	"panel.element": "Елемент",
	"panel.element.position": "Позиція",
	"panel.element.size": "Розмір",
	"panel.element.origin": "Точка оберту",
	"panel.element.rotation": "Обертання",
	"message.canvas_limit_error.title": "Помилка обмеження полотна",
	"message.canvas_limit_error.message": "Дія не може бути виконана коректно, оскільки формат обмежує полотно 48 одиницями. Змістіть точку оберту, щоб запобігти цьому.",
	"data.effect": "Ефект",
	"generic.name": "Назва",
	"settings.recent_projects": "Обмеження недавніх моделей",
	"settings.recent_projects.desc": "Максимальна кількість недавніх моделей для збереження",
	"settings.volume": "Гучність",
	"settings.volume.desc": "Регулювання гучності звукових ефектів в анімації",
	"action.clear_timeline": "Очистити часову шкалу",
	"action.clear_timeline.desc": "Очистити всі невиділені кістки з часової шкали",
	"action.select_effect_animator": "Анімувати ефекти",
	"action.select_effect_animator.desc": "Відкриває часову шкалу для додавання звуку та ефектів частинок",
	"action.timeline_focus": "Фільтри каналів",
	"action.timeline_focus.desc": "Вибрати канали анімації для показу на часовій шкалі",
	"timeline.particle": "Частинки",
	"timeline.sound": "Звук",
	"timeline.effects": "Ефекти",
	"data.format": "Формат",
	"format.optifine_part": "Частина OptiFine",
	"format.optifine_part.desc": "Частина JPM для моделей сутностей OptiFine",
	"action.reverse_keyframes": "Змінити порядок кадрів",
	"action.reverse_keyframes.desc": "Змінити порядок виділених кадрів",
	"generic.help": "Довідка",
	"message.removed_faces": "Вилучено грані: %0",
	"dialog.sketchfab_uploader.draft": "Чернетка",
	"action.slider_pos": "Позиція %0",
	"action.slider_pos.desc": "Перемістити елементи по осі %0",
	"action.slider_size": "Розмір %0",
	"action.slider_size.desc": "Змінити розмір елементів по осі %0",
	"action.slider_rotation": "Обертання %0",
	"action.slider_rotation.desc": "Обертати елементи по осі %0",
	"action.slider_origin": "Точка оберту %0",
	"action.slider_origin.desc": "Перемістити точку оберту по осі %0",
	"action.rotate_cw": "Обертати %0 +90",
	"action.rotate_cw.desc": "Обертати виділені елементи на 90° по осі %0",
	"action.rotate_ccw": "Обертати %0 -90",
	"action.rotate_ccw.desc": "Обертати виділені елементи на -90° по осі %0",
	"action.flip": "Перевернути %0",
	"action.flip.desc": "Перевернути вибрані елементи по осі %0",
	"action.center": "Відцентрувати %0",
	"action.center.desc": "Відцентрувати вибрані елементи по осі %0",
	"action.bring_up_all_animations": "Показати всіх аніматорів",
	"panel.bone": "Кістка",
	"data.color": "Колір",
	"generic.export": "Експортувати",
	"generic.none": "Немає",
	"status_bar.recording": "Ведеться прискорений запис",
	"message.add_to_palette": "Додано до палітри",
	"message.size_modifiers": "Утримуйте Ctrl або Shift, щоб трансформувати з меншим значенням.",
	"message.timelapse_start": "Прискорений запис розпочато",
	"message.timelapse_stop": "Прискорений запис зупинено",
	"message.import_palette.replace_palette": "Замінити стару палітру",
	"message.import_palette.threshold": "Об’єднати поріг",
	"dialog.timelapse.interval": "Інтервал (у секундах)",
	"dialog.timelapse.source": "Джерело",
	"dialog.timelapse.source.interface": "Інтерфейс",
	"dialog.timelapse.source.locked": "Заблокований кут",
	"dialog.timelapse.destination": "Тека призначення",
	"layout.color.checkerboard": "Шахівниця",
	"layout.color.checkerboard.desc": "Тло полотна та редактор UV",
	"layout.font.code": "Шрифт коду",
	"layout.css": "Користувацький CSS",
	"settings.category.paint": "Малювання",
	"settings.deactivate_size_limit": "Вимкнути обмеження розміру",
	"settings.deactivate_size_limit.desc": "Вимкнути обмеження розміру для певних форматів моделей. УВАГА: це може призвести до створення недійсних моделей.",
	"settings.brush_opacity_modifier": "Модифікатор непрозорості пензля",
	"settings.brush_opacity_modifier.desc": "Змінити непрозорість пензля під час використання стилуса",
	"settings.brush_size_modifier": "Модифікатор розміру пензля",
	"settings.brush_size_modifier.desc": "Змінити розмір пензля під час використання стилуса",
	"settings.brush_modifier.pressure": "При натисканні",
	"settings.brush_modifier.tilt": "При нахиленні",
	"category.color": "Колір",
	"action.import_theme": "Імпортувати тему",
	"action.export_theme": "Експортувати тему",
	"action.export_theme.desc": "Створити файл теми на основі поточних налаштувань",
	"action.slider_color_h": "Відтінок",
	"action.slider_color_s": "Насиченість",
	"action.slider_color_v": "Значення",
	"action.add_to_palette": "Додати до палітри",
	"action.add_to_palette.desc": "Додати вибраний колір до палітри кольорів",
	"action.import_palette": "Імпортувати палітру",
	"action.import_palette.desc": "Імпортувати файл палітри",
	"action.export_palette": "Експортувати палітру",
	"action.export_palette.desc": "Експортувати палітру як файл .GPL",
	"action.generate_palette": "Згенерувати палітру...",
	"action.generate_palette.desc": "Згенерувати палітру з текстури",
	"action.sort_palette": "Упорядкувати палітру",
	"action.sort_palette.desc": "Упорядкувати всі кольори на палітрі за кольором і яскравістю",
	"action.timelapse": "Прискорений запис...",
	"action.timelapse.desc": "Провести прискорений запис процесу моделювання",
	"action.add_keyframe": "Додати кадр",
	"action.add_keyframe.desc": "Додати кадр до виділеного аніматора",
	"action.bring_up_all_animations.desc": "Повертає усі змінені аніматори до часової шкали",
	"timeline.timeline": "Інструкції",
	"menu.palette.load.default": "Усталена",
	"generic.import": "Імпортувати",
	"settings.brush_modifier.none": "Немає",
	"action.export_entity": "Експортувати сутність Bedrock",
	"action.export_entity.desc": "Експортувати модель як модель сутності для Minecraft Bedrock Edition",
	"settings.highlight_cubes": "Підсвічувати елементи",
	"settings.highlight_cubes.desc": "Підсвічувати елементи під час наведення на них або виділенні",
	"action.add_marker": "Установити мітку",
	"action.add_marker.desc": "Установити мітку часової шкали",
	"timeline.pre_effect_script": "Скрипт",
	"format.skin": "Скин Minecraft",
	"format.skin.desc": "Редагувати скини гравців та сутностей",
	"message.sketchfab.setup_guide": "Хочете навчитися налаштовувати моделі в Sketchfab? Прочитайте %0",
	"dialog.skin.title": "Створити скин Minecraft",
	"dialog.skin.model": "Модель",
	"action.toggle_skin_layer": "Перемкнути видимість шару скина",
	"action.toggle_skin_layer.desc": "Перемкнути видимість шару головного убору та одягу моделі скина",
	"action.gui_light": "Освітлення інтерфейсу",
	"action.gui_light.desc": "Обрати спосіб підсвічування предмета в інвентарі",
	"action.gui_light.side": "Бічне освітлення",
	"action.gui_light.front": "Переднє освітлення",
	"action.move_keyframe_back": "Перемістити кадри назад",
	"action.move_keyframe_forth": "Перемістити кадри вперед",
	"menu.help": "Довідка",
	"menu.help.discord": "Сервер Discord",
	"menu.help.report_issue": "Повідомити про помилку",
	"menu.help.plugin_documentation": "Документація API плагіна",
	"menu.help.search_action": "Пошук та запуск дії",
	"menu.help.donate": "Підтримати",
	"menu.help.about": "Про застосунок...",
	"menu.preview.background.clipboard": "Завантажити з буфера обміну",
	"dialog.ignore": "Ігнорувати",
	"generic.unset": "Не задано",
	"message.invalid_builtin_parent.title": "Недійсний вбудований батьківський елемент",
	"message.invalid_builtin_parent.message": "Посилання на недійсний батьківський елемент моделі «%0» було видалено для того, щоб експортувати дійсну модель.",
	"dialog.resize_texture.fill": "Заповнити",
	"dialog.resize_texture.fill.transparent": "Прозорістю",
	"dialog.resize_texture.fill.color": "Кольором",
	"dialog.resize_texture.fill.repeat": "Повторенням",
	"dialog.scale.element_pivot": "Точка оберту елемента",
	"dialog.scale.selection_center": "Центр вибору",
	"dialog.create_gif.length_mode": "Режим тривалості",
	"dialog.create_gif.length_mode.seconds": "Секунди",
	"dialog.create_gif.length_mode.frames": "Кадри",
	"dialog.create_gif.length_mode.animation": "Довжина анімації",
	"dialog.create_gif.length_mode.turntable": "Обертання відтворення",
	"dialog.save_angle.projection": "Проєкція",
	"dialog.save_angle.projection.perspective": "Перспектива",
	"dialog.save_angle.projection.orthographic": "Орфографічна",
	"dialog.sketchfab_uploader.animations": "Анімації",
	"dialog.settings.theme": "Тема",
	"settings.category.interface": "Інтерфейс",
	"settings.preview_checkerboard": "Шахівниця",
	"settings.preview_checkerboard.desc": "Увімкнути/вимкнути тло шахівниці позаду моделі",
	"settings.uv_checkerboard": "Шахівниця редактора UV",
	"settings.uv_checkerboard.desc": "Перемикати видимість тла шахівниці за редактором UV",
	"category.paint": "Малювати",
	"action.fill_mode.color_connected": "Поєднані кольори",
	"action.draw_shape_type": "Тип форми",
	"action.draw_shape_type.rectangle": "Прямокутник",
	"action.draw_shape_type.rectangle_h": "Прямокутник (порожній)",
	"action.draw_shape_type.ellipse": "Коло",
	"action.draw_shape_type.ellipse_h": "Коло (порожнє)",
	"action.draw_shape_type.line": "Лінія",
	"action.mirror_painting": "Дзеркальне малювання",
	"action.mirror_painting.description": "Дзеркально перенести штрихи фарби на іншу сторону моделі",
	"action.lock_alpha": "Заблокувати альфа-канал",
	"action.lock_alpha.description": "Заблокувати прозорість усіх пікселів",
	"action.draw_shape_tool": "Фігура",
	"action.draw_shape_tool.desc": "Інструмент для малювання простих фігур на текстурах",
	"action.export_gltf": "Експортувати модель glTF",
	"action.export_gltf.desc": "Експортувати модель й анімації як файл glTF для розповсюдження і візуалізації",
	"action.transform_space": "Простір трансформації",
	"action.transform_space.desc": "Усталений простір трансформації для елементів та кісток",
	"action.transform_space.global": "Глобальний",
	"action.transform_space.local": "Локальний",
	"action.toggle_camera_projection": "Проєкція камери",
	"action.toggle_camera_projection.desc": "Перемкнути проєкцію камери між перспективою та орфографією",
	"action.load_camera_angle": "Кут камери: %0",
	"action.load_camera_angle.desc": "Завантажити кут камери «%0»",
	"action.slider_face_tint": "Індекс тіні",
	"action.slider_face_tint.desc": "Задати індекс тіні поточної сторони. -1 — не задано.",
	"menu.help.quickstart": "Посібник початку роботи",
	"menu.help.developer": "Розробник",
	"menu.help.developer.dev_tools": "Інструменти розробника",
	"menu.help.developer.reset_storage": "Скинути до заводських налаштувань",
	"menu.help.developer.reset_storage.confirm": "Ви дійсно бажаєте скинути Blockbench до заводських налаштувань? Це призведе до видалення всіх користувацьких налаштувань, сполучень клавіш та встановлених плагінів.",
	"menu.help.developer.cache_reload": "Перезавантажити кеш",
	"menu.preview.orthographic": "Орфографія",
	"menu.preview.save_angle": "Зберегти кут...",
	"menu.preview.angle": "Кути",
	"menu.preview.angle.initial": "Початковий кут",
	"menu.preview.maximize": "Розгорнути",
	"uv_editor.copy_selection": "Копіювати виділення",
	"uv_editor.paste_selection": "Вставити виділення",
	"uv_editor.copy_paste_tool.place": "Розмістити",
	"uv_editor.copy_paste_tool.mirror_x": "Віддзеркалити по X",
	"uv_editor.copy_paste_tool.mirror_y": "Віддзеркалити по Y",
	"uv_editor.copy_paste_tool.rotate": "Обертати на 90 градусів",
	"dialog.project.modded_entity_version": "Версія експорту",
	"dialog.save_angle.position": "Позиція камери",
	"dialog.save_angle.target": "Точка фокусу",
	"dialog.skin.pose": "Поза",
	"layout.color.frame": "Рамка вікна",
	"layout.color.frame.desc": "Рамка та заголовок вікна",
	"settings.large_grid_size": "Розмір великої сітки",
	"settings.large_grid_size.desc": "Розмір сітки блоків",
	"action.load_plugin_from_url": "Завантажити плагін з URL",
	"action.load_plugin_from_url.desc": "Завантажити плагін із сервера, вказавши URL-адресу",
	"action.cube_counter.desc": "Показує поточну кількість елементів та інші показники",
	"action.unlock_everything": "Розблокувати все",
	"action.unlock_everything.desc": "Розблокувати всі групи та елементи у планувальнику.",
	"action.load_palette": "Завантажити палітру",
	"action.load_palette.desc": "Завантажити один із вбудованих або збережених шаблонів палітри",
	"action.toggle_locked": "Блокування",
	"action.toggle_locked.desc": "Перемкнути блокування виділених елементів",
	"action.apply_display_preset": "Застосувати шаблон",
	"action.apply_display_preset.desc": "Застосувати усталений або власний шаблон показу",
	"action.apply_display_preset.here": "Застосувати до цього слота",
	"action.apply_display_preset.everywhere": "Застосувати до всіх слотів",
	"action.resolve_keyframe_expressions": "Розв’язати кадр",
	"action.resolve_keyframe_expressions.desc": "Розв’язує математичні вирази виділених кадрів",
	"action.fold_all_animations": "Згорнути всіх аніматорів",
	"menu.palette.load.empty": "Порожня",
	"switches.lock": "Заблокувати",
	"settings.render_sides": "Сторони візуалізації",
	"settings.render_sides.desc": "Оберіть, який бік грані візуалізувати",
	"settings.render_sides.auto": "Автоматично",
	"settings.render_sides.front": "Ззовні",
	"settings.render_sides.double": "Зсередини та ззовні",
	"generic.enable": "Увімкнути",
	"generic.disable": "Вимкнути",
	"generic.redacted": "Відредаговано",
	"dialog.select_texture.import_all": "Імпортувати все",
	"dialog.skin.layer_template": "Текстура шару",
	"about.version.up_to_date": "Актуальна",
	"about.version.update_available": "Доступна версія %0",
	"settings.category.application": "Застосунок",
	"settings.streamer_mode": "Режим стримера",
	"settings.streamer_mode.desc": "Приховує конфіденційну інформацію, як-от недавні моделі",
	"settings.automatic_updates": "Автоматичні оновлення",
	"settings.automatic_updates.desc": "Автоматично завантажувати нові версії та тримати Blockbench оновленим",
	"action.rotation_space": "Простір обертання",
	"action.focus_on_selection": "Відцентрувати вид на виділенні",
	"action.focus_on_selection.desc": "Вирівняти камеру навпроти центру поточного виділення",
	"action.jump_to_timeline_start": "Перейти до початку анімації",
	"action.jump_to_timeline_end": "Перейти до кінця анімації",
	"menu.help.updating": "Оновлення (%0%)",
	"menu.help.update_failed": "Не вдалося оновити",
	"menu.animation.loop.once": "Відтворити один раз",
	"menu.animation.loop.hold": "Зупинити на останньому кадрі",
	"menu.animation.loop.loop": "Цикл",
	"interface.streamer_mode_on": "Режим стримера ввімкнено",
	"generic.reset": "Скинути",
	"generic.restore": "Відновити",
	"keys.mousewheel": "Коліщатко миші",
	"message.delete_animation.title": "Видалити анімацію",
	"message.delete_animation.message": "Анімацію було видалено з Blockbench. Бажаєте видалити анімацію з файлу, в якому вона була збережена?",
	"message.no_animation_to_import": "Немає анімацій для імпорту",
	"dialog.material_instances.title": "Екземпляри матеріалів",
	"dialog.animation_import.title": "Оберіть анімації для імпорту",
	"dialog.create_texture.padding": "Відступ",
	"settings.fov": "Поле зору",
	"settings.fov.desc": "Поле зору камери. Усталене значення — 45",
	"settings.minify_bbmodel": "Мінімізовані файли проєкту",
	"settings.minify_bbmodel.desc": "Записувати файли .bbmodel в один рядок",
	"action.edit_material_instances": "Редагувати екземпляри матеріалів",
	"action.edit_material_instances.desc": "Змінити назви екземплярів матеріалів для геометрії блоків Bedrock Edition",
	"action.save_all_animations": "Зберегти всі анімації",
	"action.save_all_animations.desc": "Зберегти всі поточно завантажені анімації",
	"action.keyframe_interpolation": "Інтерполяція",
	"action.keyframe_interpolation.desc": "Оберіть режим інтерполяції кадрів",
	"action.keyframe_interpolation.linear": "Лінійний",
	"action.keyframe_interpolation.catmullrom": "Плавний",
	"action.timeline_focus.hide_empty": "Сховати порожні канали",
	"menu.file.preferences": "Уподобання",
	"menu.animation.blend_weight": "Сила змішання",
	"menu.animation.save": "Зберегти",
	"menu.animation.properties": "Властивості...",
	"menu.animation.file": "Файл",
	"menu.animation.snapping": "Прив’язка",
	"menu.animation.open_location": "Показати у провіднику файлів",
	"panel.keyframe.add_data_point": "Додати точку даних кадру",
	"panel.keyframe.remove_data_point": "Вилучити точку даних",
	"panel.keyframe.pre": "Пре",
	"panel.keyframe.post": "Пост",
	"generic.all": "Усе",
	"message.small_face_dimensions.title": "Несумісні розміри грані",
	"message.small_face_dimensions.message": "Виділення містить грані, ширина яких менша за 1 в одному напрямку. Система мапування коробки UV вважає, що всі грані, менші за цей поріг, мають ширину 0 пікселів. Тому текстура на цих гранях може працювати некоректно.",
	"message.small_face_dimensions.face_uv": "Поточний формат підтримує «Для кожної UV грані», які можуть обробляти малі розміри поверхні. Перейдіть до «Файл» > «Проєкт...» і змініть «Режим UV» на «Для кожної UV грані».",
	"dialog.plugins.outdated_client": "Потребує новішої версії Blockbench",
	"dialog.plugins.outdated_plugin": "Плагін застарів і не працює з цією версією Blockbench",
	"settings.motion_trails": "Сліди руху",
	"settings.motion_trails.desc": "Показувати сліди руху в редакторі анімацій",
	"settings.antialiasing": "Згладжування",
	"settings.antialiasing.desc": "Перемкнути стан згладжування у перегляді",
	"action.timeline_frame_back": "Перейти на 1 кадр назад",
	"action.timeline_frame_forth": "Перейти на 1 кадр уперед",
	"panel.bone.ik": "Зворотна кінематика (експериментальна)",
	"settings.particle_tick_rate": "Частота такту частинок",
	"settings.particle_tick_rate.desc": "Частота такту для ефектів частинок у тактах на секунду. Усталене значення — 30",
	"action.lock_motion_trail": "Зафіксувати сліди руху",
	"action.lock_motion_trail.desc": "Зафіксувати сліди руху до поточної виділеної групи",
	"menu.animation_file.unload": "Розвантажити файл",
	"data.null_object": "Пустий об’єкт",
	"status_bar.toggle_sidebar": "Бічна панель",
	"message.load_plugin_failed.title": "Не вдалося завантажити плагін",
	"message.load_plugin_failed.message": "Переконайтеся, що назва базового файлу плагіна збігається з ідентифікатором плагіна `%0`, вказаним у Plugin.register().",
	"dialog.project.uv_mode": "Режим UV",
	"dialog.project.uv_mode.box_uv": "Коробка UV",
	"dialog.project.uv_mode.face_uv": "Для кожної UV грані",
	"dialog.project.texture_size": "Розмір текстури",
	"dialog.animation_export.title": "Оберіть анімації для експорту",
	"dialog.create_texture.rearrange_uv": "Переставити UV",
	"layout.color.subtle_text": "Субтильний текст",
	"layout.color.subtle_text.desc": "Вторинний колір тексту з меншим контрастом",
	"settings.interface_scale": "Розмір інтерфейсу",
	"settings.interface_scale.desc": "Розмір усього інтерфейсу Blockbench",
	"settings.background_rendering": "Фонова візуалізація",
	"settings.background_rendering.desc": "Оновлювати перегляд, коли вікно не сфокусовано",
	"settings.ctrl_shift_size": "Роздільність Control + Shift",
	"settings.ctrl_shift_size.desc": "Роздільність сітки під час утримання Control + Shift",
	"settings.hardware_acceleration": "Апаратне прискорення",
	"settings.hardware_acceleration.desc": "Розподілити завдання візуалізації на відеокарту",
	"action.explode_skin_model": "Розкладена модель скина",
	"action.explode_skin_model.desc": "Перемикає стан розкладеного вигляду, який дозволяє редагувати прикриті грані",
	"action.export_minecraft_skin": "Експортувати скин Minecraft",
	"action.export_minecraft_skin.desc": "Експортувати скин Minecraft як PNG",
	"action.add_null_object": "Додати пустий об’єкт",
	"action.add_null_object.desc": "Додає новий пустий об’єкт",
	"action.animated_texture_frame": "Кадр анімованої текстури",
	"action.animated_texture_frame.desc": "Задати поточний кадр анімованої текстури",
	"action.export_animation_file": "Експортувати анімації...",
	"action.export_animation_file.desc": "Експортувати добірку анімацій у новий файл",
	"action.timeline_graph_editor": "Графічний редактор",
	"action.timeline_graph_editor.desc": "Перемкнути часову шкалу між режимом перегляду графічного редактора і режимом перегляду кадрів",
	"menu.file.recent.clear": "Очистити недавні файли",
	"switches.shade": "Тіні",
	"generic.share": "Поділитися",
	"dates.minute": "%0 хвилину",
	"dates.minutes": "%0 хв.",
	"dates.hour": "%0 годину",
	"dates.hours": "%0 год.",
	"dates.day": "%0 день",
	"dates.days": "%0 дн.",
	"dates.week": "%0 тиждень",
	"dates.weeks": "%0 тижн.",
	"dates.year": "%0 рік",
	"dates.years": "%0 рр.",
	"message.installed_plugin": "Успішно встановлено плагін «%0»",
	"message.installed_plugin_fail": "Не вдалося встановити плагін «%0»",
	"dialog.share_model.title": "Поділитися моделлю",
	"dialog.share_model.expire_time": "Термін дії",
	"dialog.share_model.failed": "Не вдалося вивантажити модель",
	"action.import_java_block_model": "Додати модель блоку/предмета Java",
	"action.import_java_block_model.desc": "Додати модель блоку/предмета Java Minecraft із файлу .json до поточної моделі",
	"action.share_model": "Поділитися...",
	"action.share_model.desc": "Створити коротке посилання, щоб поділитися моделлю",
	"action.import_project": "Імпортувати проєкт",
	"action.import_project.desc": "Імпортувати інший проєкт із файлу .bbmodel у поточний проєкт",
	"dialog.toolbar_edit.hidden_tools": "Деякі інструменти можуть бути приховані, оскільки вони недоступні в поточному режимі, форматі або ситуації.",
	"settings.camera_near_plane": "Камера поблизу площини",
	"settings.camera_near_plane.desc": "Мінімальна відстань від камери, на якій візуалізуються об’єкти. Вищі значення зменшують Z-конфлікти. Усталене значення — 1.",
	"mode.start.keymap_preference.desc": "Якщо ви початківець у Blockbench і переходите з іншого 3D-застосунку, ви можете вибрати розкладку клавіш для полегшення переходу. Ви можете змінити розкладку клавіш або окремі сполучення клавіш пізніше у налаштуваннях.",
	"message.load_keymap": "Ви дійсно бажаєте завантажити цю розкладку клавіш? Це перезапише ваші поточні сполучення клавіш.",
	"message.keymap_loaded": "Розкладку клавіш завантажено",
	"dialog.convert_project.current_format": "Поточний формат",
	"dialog.create_texture.rearrange_uv.desc": "Створити нову UV розкладку, щоб кожна грань мала власне місце на текстурі",
	"dialog.create_texture.power.desc": "Блокувати автоматичний розмір текстури зі степенем 2, наприклад, 64 або 128. Це вимагається деякими візуалізаторами",
	"dialog.create_texture.double_use.desc": "Якщо двом елементам уже призначено однаковий UV простір, залишити його таким у новій мапі",
	"dialog.create_texture.padding.desc": "Додати невеликий відступ між окремими частинами шаблону",
	"dialog.create_texture.resolution.desc": "Висота і ширина текстури",
	"dialog.create_gif.color": "Колір тла",
	"dialog.save_angle.zoom": "Масштаб",
	"dialog.skin.variant": "Варіант",
	"dialog.flip_animation.info": "Протилежні кістки позначені ключовими словами 'ліва' та 'права' в їхніх назвах.",
	"dialog.export_private_settings.title": "Налаштування приватності",
	"dialog.export_private_settings.message": "Ваш файл містить наступну приватну інформацію: **%0**. Не вказуйте ці значення, якщо ви плануєте поділитися файлом з кимось іншим.",
	"dialog.export_private_settings.keep": "Зберегти",
	"settings.timecode_frame_number": "Часовий код як номери кадрів",
	"settings.timecode_frame_number.desc": "Показувати часові коди фрагментів на часовій шкалі як номер кадру замість сантисекунд",
	"settings.animation_sample_rate": "Частота вибірки анімації",
	"settings.animation_sample_rate.desc": "Частота вибірки у відліках на секунду для кривих елементів, які не підтримуються відповідним форматом від початку",
	"keybind.preview_zoom": "Вид масштабу",
	"action.gradient_tool": "Градієнт",
	"action.gradient_tool.desc": "Створити градієнт кольору на текстурі",
	"action.import_settings": "Імпорт налаштувань",
	"action.import_settings.desc": "Імпортувати файл .bbsettings",
	"action.export_settings": "Експорт налаштувань",
	"action.export_settings.desc": "Експортувати налаштування Blockbench як файл .bbsettings",
	"action.load_keymap": "Завантажити розкладку",
	"action.load_keymap.default": "Усталено (сенсорна панель/миша)",
	"action.load_keymap.mouse": "Усталено (миша)",
	"action.load_keymap.default.desc": "Усталене сполучення клавіш Blockbench із навігацією у вікні перегляду, оптимізованими для використання на сенсорних панелях ноутбуків",
	"action.load_keymap.mouse.desc": "Усталене сполучення клавіш Blockbench із навігацією у вікні перегляду, призначеною до середньої кнопки миші",
	"action.load_keymap.blender.desc": "Розкладка клавіш для користувачів, які знайомі з елементами керування Blender",
	"action.load_keymap.cinema4d.desc": "Розкладка клавіш для користувачів, які знайомі з елементами керування Cinema 4D",
	"action.load_keymap.maya.desc": "Розкладка клавіш для користувачів, які знайомі з елементами керування Autodesk Maya",
	"action.import_keymap": "Імпортувати розкладку",
	"action.import_keymap.desc": "Імпортувати розкладку клавіш з файла .bbkeymap",
	"action.export_keymap": "Експортувати розкладку",
	"action.export_keymap.desc": "Експортувати поточну розкладку клавіш як файл .bbkeymap",
	"action.edit_history": "Історія редагування...",
	"action.edit_history.desc": "Переглянути історію редагування та скасувати або відновити дію",
	"action.group_elements": "Елементи групи",
	"action.group_elements.desc": "Завернути виділені елементи в нову групу",
	"action.unfold_groups": "Розгорнути групи",
	"action.unfold_groups.desc": "Розгорнути всі групи у планувальнику",
	"action.edit_bedrock_binding": "Редагувати прив’язку...",
	"action.edit_bedrock_binding.desc": "Змінити, до якої кістки прив’язана геометрія",
	"action.pick_screen_color": "Обрати колір з екрана",
	"action.pick_screen_color.desc": "Обрати колір десь на екрані",
	"action.view_mode": "Режим вигляду",
	"action.view_mode.desc": "Змінити режим вигляду моделі",
	"action.view_mode.textured": "З текстурою",
	"action.view_mode.solid": "Суцільна",
	"action.view_mode.wireframe": "Каркас",
	"action.toggle_sidebars": "Перемикнути бічні панелі",
	"action.toggle_sidebars.desc": "Увімкнути або вимкнути бічні панелі",
	"action.set_animation_end": "Задати кінець анімації",
	"action.set_animation_end.desc": "Задати кінець вибраної анімації на поточний час на шкалі часу",
	"action.flip_animation": "Перевернути анімацію",
	"action.flip_animation.desc": "Перевертає частину анімації, копіюючи виділені кадри на іншу сторону моделі",
	"action.graph_editor_zero_line": "Include Zero Line",
	"action.graph_editor_zero_line.desc": "Whether the graph editor always includes the zero line in the view",
	"menu.texture.render_mode": "Режим візуалізації",
	"menu.texture.render_mode.emissive": "Випромінний",
	"menu.texture.render_mode.layered": "Шаруватий",
	"menu.preview.angle.edit": "Редагувати кут...",
	"menu.animation.start_delay": "Затримка початку",
	"menu.animation.loop_delay": "Затримка циклу",
	"menu.animation.flip_keyframes": "Перевернути кадри",
	"menu.mobile_keyboard.disable_all": "Вимкнути все",
	"panel.keyframe.toggle_uniform_scale": "Перемкнути рівномірне масштабування",
	"camera_angle.common_isometric_right": "Ізометрія справа (2:1)",
	"camera_angle.common_isometric_left": "Ізометрія зліва (2:1)",
	"camera_angle.true_isometric_right": "Справжня ізометрія справа (30°)",
	"camera_angle.true_isometric_left": "Справжня ізометрія зліва (30°)",
	"menu.help.wiki": "Вікі Blockbench",
	"settings.update_to_prereleases": "Оновлюватися до пре-випусків",
	"settings.update_to_prereleases.desc": "Автоматично оновлюватися до бета-версій Blockbench для тестування нових функцій. Версії пре-випусків можуть бути нестабільними, не вмикайте цей параметр, якщо ви покладаєтеся на Blockbench для роботи або інших важливих проєктів.",
	"data.separator.spacer": "Розпірка",
	"data.separator.linebreak": "Розрив рядка",
	"data.setting": "Налаштування",
	"generic.select_all": "Виділити все",
	"generic.select_none": "Прибрати виділення",
	"projects.new_tab": "Нова вкладка",
	"projects.close_tab": "Закрити вкладку",
	"message.invalid_format.title": "Недійсний формат",
	"message.invalid_format.message": "Ця модель була створена у форматі «%0», який недоступний у Blockbench. Швидше за все, вам потрібен спеціальний плагін, щоб коректно відкрити її.",
	"message.invalid_link": "Недійсне або застаріле посилання на модель",
	"message.default_textures.current": "Поточний шлях",
	"message.update_after_restart": "Оновлення буде встановлено після наступного перезапуску",
	"message.copy_paste_tool_viewport": "Цей інструмент можна використовувати лише в 2D-редакторі",
	"dialog.project.shadow_size": "Розмір тіні",
	"dialog.find_replace.target": "Ціль",
	"dialog.find_replace.target.element_names": "Назви елементів",
	"dialog.find_replace.target.group_names": "Назви груп",
	"dialog.find_replace.target.animation_names": "Назви анімацій",
	"dialog.find_replace.target.keyframe_values": "Значення кадрів",
	"dialog.find_replace.find": "Знайти",
	"dialog.find_replace.replace": "Замінити",
	"dialog.find_replace.regex": "Регулярний вираз",
	"dialog.add_primitive.shape": "Форма",
	"dialog.add_primitive.shape.circle": "Коло",
	"dialog.add_primitive.shape.tube": "Труба",
	"dialog.add_primitive.shape.cone": "Конус",
	"dialog.add_primitive.shape.cylinder": "Циліндр",
	"dialog.add_primitive.shape.sphere": "Сфера",
	"dialog.add_primitive.shape.torus": "Тор",
	"dialog.add_primitive.shape.cube": "Куб",
	"dialog.add_primitive.shape.pyramid": "Піраміда",
	"dialog.add_primitive.diameter": "Діаметр",
	"dialog.add_primitive.height": "Висота",
	"dialog.add_primitive.sides": "Сторони",
	"dialog.add_primitive.minor_diameter": "Товщина",
	"dialog.add_primitive.minor_sides": "Другорядні сторони",
	"dialog.create_texture.combine_polys": "Combine Islands",
	"dialog.create_texture.combine_polys.desc": "Combine faces into connected UV islands",
	"dialog.model_stats.meshes": "Меші",
	"dialog.export_private_settings.omit": "Пропустити",
	"layout.select": "Вибрати",
	"layout.options": "Параметри",
	"layout.color": "Колірна схема",
	"layout.documentation": "Документація",
	"layout.color.bright_ui_text": "Bright UI Text",
	"layout.color.bright_ui_text.desc": "Text on bright backgrounds",
	"layout.name": "Назва",
	"layout.author": "Автор",
	"settings.dialog.desc": "Показувати діалогове вікно «%0»",
	"settings.export_empty_groups": "Експорт порожніх груп",
	"settings.export_empty_groups.desc": "Включати групи без вмісту до експортованих файлів",
	"category.separators": "Роздільники",
	"keybind.preview_area_select": "Виділити область",
	"action.color_erase_mode": "Режим гумки",
	"action.color_erase_mode.desc": "Увімкнувши режим гумки, такі інструменти, як «Заливка» та «Прямокутник», віднімають кольори, а не додають їх",
	"action.open_from_link": "Відкрити модель за посиланням",
	"action.open_from_link.desc": "Відкрити модель з посилання blckbn.ch",
	"action.import_obj": "Імпортувати модель OBJ",
	"action.import_obj.desc": "Імпортує об’єкти з моделі OBJ як меші",
	"action.add_plugin": "Установити плагін",
	"action.add_plugin.desc": "Установіть плагін через контроль дій",
	"action.remove_plugin": "Видалити плагін",
	"action.remove_plugin.desc": "Видалити плагін через контроль дій",
	"action.add_mesh": "Додати меш",
	"action.add_mesh.desc": "Додає новий меш",
	"action.add_texture_mesh": "Додати текстурний меш",
	"action.add_texture_mesh.desc": "Додає новий текстурний меш",
	"action.find_replace": "Знайти/Замінити...",
	"action.find_replace.desc": "Знайти та замінити частини назв",
	"action.hide_everything_except_selection": "Приховати все, крім виділеного",
	"action.hide_everything_except_selection.desc": "Перемикнути видимість для всіх елементів, окрім вибраних",
	"action.transform_space.normal": "Нормальний",
	"action.selection_mode": "Режим виділення",
	"action.selection_mode.desc": "Змінити спосіб вибору елементів в області перегляду",
	"action.selection_mode.object": "Об’єкт",
	"action.selection_mode.face": "Грань",
	"action.selection_mode.vertex": "Вершина",
	"action.create_face": "Створити грань або ребро",
	"action.create_face.desc": "Створює нову грань або ребро між виділеними вершинами",
	"action.convert_to_mesh": "Конвертувати у меш",
	"action.convert_to_mesh.desc": "Конвертувати виділені елементи у меш",
	"action.invert_face": "Перевернути грань",
	"action.invert_face.desc": "Перевернути виділені грані, щоб вони були звернені в протилежному напрямку",
	"action.extrude_mesh_selection": "Extrude Selection",
	"action.extrude_mesh_selection.desc": "Extrude the selected parts of the mesh",
	"action.loop_cut": "Loop Cut",
	"action.loop_cut.desc": "Розділити сітку петлею по виділеному ребру",
	"action.merge_meshes": "Об’єднати сітки",
	"action.merge_meshes.desc": "Об’єднати кілька сіток в одну",
	"action.keyframe_uniform": "Рівномірне масштабування",
	"action.keyframe_uniform.desc": "Увімкнути рівномірне масштабування на виділених кадрах",
	"menu.locator.ignore_inherited_scale": "Ігнорувати успадкований масштаб",
	"menu.texture.elements": "Застосувати до елементів",
	"uv_editor.transparent_face": "Прозора грань",
	"display.pose_angle": "Кут пози (Лише для перегляду)",
	"data.mesh": "Меш",
	"dialog.create_texture.type": "Тип",
	"dialog.create_texture.type.blank": "Порожня",
	"dialog.create_texture.type.template": "Шаблон текстури",
	"dialog.create_texture.type.color_map": "Однотонний шаблон",
	"dialog.sketchfab_uploader.suggested_tags": "Запропоновані теги",
	"dialog.sketchfab_uploader.category": "Категорія",
	"dialog.sketchfab_uploader.category2": "Категорія 2",
	"layout.restore_backup": "Вашу власну тему «%0» було перезаписано. Натисніть, щоб відновити її.",
	"layout.borders": "Межі",
	"action.fill_mode.element": "Елемент",
	"action.inset_mesh_selection": "Вставити виділене",
	"action.inset_mesh_selection.desc": "Вставити виділені частини меша",
	"action.dissolve_edges": "Розчинити ребра",
	"action.dissolve_edges.desc": "Розчинити виділені ребра у сітки та об’єднати грані, які вони розділяють",
	"action.split_mesh": "Розділити меш",
	"action.split_mesh.desc": "Розділити виділені грані меша на новий меш",
	"action.merge_vertices": "Об’єднати вершини",
	"action.merge_vertices.desc": "Об’єднати виділені вершини у позицію першої виділеної вершини",
	"action.view_mode.normal": "Орієнтація грані",
	"action.snap_uv_to_pixels": "Прив’язати UV до пікселів",
	"action.snap_uv_to_pixels.desc": "Прив’язує вибрані вершини UV до піксельної сітки",
	"menu.file.import.import_open_project": "Імпортувати відкритий проєкт",
	"menu.help.unlock_projects": "Розблокувати всі проєкти",
	"status_bar.selection.faces": "%0 грань",
	"status_bar.selection.vertices": "%0 вершин",
	"message.merged_vertices": "Знайдено та об’єднано вершини (%0) у місцях (%1)",
	"settings.vertex_merge_distance": "Відстань об’єднання вершин",
	"settings.vertex_merge_distance.desc": "Відстань, в межах якої об’єднуються вершини з об’єднанням за відстанню",
	"settings.show_only_selected_uv": "Показувати лише виділений UV",
	"settings.show_only_selected_uv.desc": "Показувати лише виділені UV грані у редакторі UV",
	"action.merge_vertices.merge_all": "Об’єднати все",
	"action.merge_vertices.merge_all_in_center": "Об’єднати все в центрі",
	"action.merge_vertices.merge_by_distance": "Об’єднати за відстанню",
	"action.merge_vertices.merge_by_distance_in_center": "Об’єднати за відстанню у центрі",
	"action.uv_rotate_left": "Повернути UV вліво",
	"action.uv_rotate_left.desc": "Повернути виділені UV грані проти годинникової стрілки",
	"action.uv_rotate_right": "Повернути UV вправо",
	"action.uv_rotate_right.desc": "Повернути виділені UV грані за годинниковою стрілкою",
	"menu.uv.display_uv": "Показ UV",
	"menu.uv.display_uv.selected_faces": "Виділені грані",
	"menu.uv.display_uv.selected_elements": "Усі грані",
	"menu.uv.display_uv.all_elements": "Усі грані на всіх елементах",
	"menu.paste.face": "UV грань",
	"menu.paste.mesh_selection": "Виділення мешу",
	"menu.paste.outliner": "Елементи",
	"uv_editor.show_all_faces": "Показати всі грані",
	"uv_editor.show_selected_faces": "Показати виділені грані",
	"status_bar.selection.edges": "%0 ребер",
	"action.selection_mode.edge": "Ребро",
	"message.cannot_re_import.title": "Модель не можна повторно імпортувати",
	"message.cannot_re_import.message": "Експортований формат моделі не може бути повторно імпортований в Blockbench. Будь ласка, не забудьте зберегти вашу модель як файл проєкту.",
	"generic.default": "Усталено",
	"units.pixels_per_meter": "%0 пікс. на метр",
	"mode.pose": "Поза",
	"modifier_actions.resize_both_sides": "Змінити розмір в обох напрямках",
	"modifier_actions.resize_one_side": "Змінити розмір в одному напрямку",
	"modifier_actions.draw_line": "Намалювати лінію",
	"modifier_actions.drag_without_snapping": "Перетягнути без прив’язування",
	"modifier_actions.stretch_keyframes": "Розтягнути кадри",
	"modifier_actions.resize_background": "Змінити розмір тла",
	"modifier_actions.select_multiple": "Вибрати декілька",
	"modifier_actions.select_range": "Вибрати діапазон",
	"modifier_actions.drag_to_duplicate": "Перетягніть, щоб скопіювати",
	"modifier_actions.uniform_scaling": "Рівномірне масштабування",
	"modifier_actions.snap_direction": "Прив’язати напрямок",
	"message.no_valid_elements": "Не вибрано дійсних елементів...",
	"dialog.add_primitive.shape.plane": "Площина",
	"dialog.save_angle.rotation_mode": "Режим обертання",
	"dialog.save_angle.rotation": "Обертання",
	"dialog.save_angle.fov": "Поле зору",
	"settings.hide_tab_bar": "Автоматично приховувати панель вкладок",
	"settings.hide_tab_bar.desc": "Приховати панель вкладок, коли відкрита лише одна вкладка",
	"settings.status_bar_modifier_keys": "Пропонувати клавіші модифікатори у рядку стану",
	"settings.status_bar_modifier_keys.desc": "Показувати контекстно-залежні запропоновані клавіші модифікатори у рядку стану",
	"settings.ground_plane": "Наземна площина",
	"settings.ground_plane.desc": "Показувати наземну площину під моделлю",
	"settings.preview_paste_behavior": "Усталена дія вставки у вікно перегляду",
	"settings.preview_paste_behavior.desc": "Виберіть поведінку під час вставки чогось до області перегляду в режимі редагування, доступно кілька варіантів",
	"settings.preview_paste_behavior.always_ask": "Завжди запитувати",
	"action.new_window": "Нове вікно",
	"action.new_window.desc": "Відкриває нове вікно Blockbench",
	"action.export_collada": "Експортувати модель Collada (DAE)",
	"action.export_collada.desc": "Експортувати модель і анімацію як файл DAE, щоб використовувати його в інших 3D-застосунках",
	"action.paint_mode_uv_overlay": "Накладання UV",
	"action.paint_mode_uv_overlay.desc": "Показати мапу UV як накладання в режимі малювання",
	"action.bake_animation_into_model": "Bake Animation into Model",
	"action.bake_animation_into_model.desc": "Bake the currently displayed animation frame into the model. Only applies rotation and position, scale is ignored.",
	"action.keyframe_interpolation.step": "Крок",
	"action.set_ik_target": "Set IK Target",
	"action.set_ik_target.desc": "Select the target bone that should be moved by this null object via Inverse Kinematics",
	"menu.action_control.type.tab": "Вкладка",
	"menu.action_control.type.angle": "Кут камери",
	"menu.action_control.recent_in_streamer_mode": "Упевнені? Режим стримера ввімкнено",
	"menu.action_control.recent_in_streamer_mode.desc": "Ви дійсно бажаєте показати недавні моделі?",
	"menu.tools": "Інструменти",
	"menu.file.recent.more": "Докладніше...",
	"menu.null_object.lock_ik_target_rotation": "Заблокувати обертання цілі IK",
	"menu.animation_file.import_remaining": "Імпортувати залишок з файлу",
	"edit.loop_cut.offset": "Зміщення",
	"edit.extrude_mesh_selection.extend": "Розгорнути",
	"cube.color.pink": "Рожевий",
	"cube.color.silver": "Сріблястий",
	"dialog.plugins.offline": "Немає підключення до Інтернету",
	"dialog.create_texture.pixel_density": "Щільність пікселів",
	"dialog.create_texture.pixel_density.desc": "Щільність пікселів текстури, у пікселях на метр. Розмір мапи текстури може відрізнятися залежно від кількості та розміру елементів.",
	"panel.skin_pose": "Поза",
	"panel.skin_pose.none": "Немає",
	"panel.skin_pose.natural": "Звичайна",
	"panel.skin_pose.walking": "Ходячи",
	"panel.skin_pose.crouching": "Навпочіпки",
	"panel.skin_pose.sitting": "Сидячи",
	"panel.skin_pose.jumping": "Стрибаючи",
	"panel.skin_pose.aiming": "Націлюючи",
	"edit.loop_cut.direction": "Напрямок",
	"data.texture_mesh": "Текстура мешу",
	"generic.left": "Ліворуч",
	"generic.right": "Праворуч",
	"mode.start.quick_setup": "Швидке налаштування",
	"mode.start.keymap": "Розкладка клавіш",
	"mode.start.quick_setup.more_themes": "Докладніше...",
	"dialog.resize_texture.animation_frames": "Кадри анімації",
	"dialog.export_emission_map.title": "Експортувати мапу джерела",
	"dialog.export_emission_map.format": "Формат",
	"dialog.export_emission_map.format.luminance": "Яскравість",
	"dialog.export_emission_map.format.luminance_inverted": "Інвертована яскравість",
	"dialog.export_emission_map.format.colors": "Кольори",
	"dialog.export_emission_map.threshold": "Поріг прозорості",
	"dialog.export_emission_map.round_up": "Округлити до %0 x %1",
	"dialog.export_emission_map.flip_y": "Перевернути вісь Y",
	"dialog.select.type": "Тип елемента",
	"dialog.create_texture.max_edge_angle": "Поріг кута ребра",
	"dialog.create_texture.max_edge_angle.desc": "Максимальний кут між двома гранями, при якому вони все ще будуть поєднані",
	"dialog.create_texture.max_island_angle": "Поріг острівного кута",
	"dialog.create_texture.max_island_angle.desc": "Максимальний кут, який можна об'єднати в один острів UV",
	"settings.mobile_panel_side": "Бічна мобільна панель",
	"settings.mobile_panel_side.desc": "Оберіть, з якого боку екрана відображатимуться панелі під час використання Blockbench у горизонтальній орієнтації",
	"settings.obj_face_export_mode": "Режим експорту грані OBJ",
	"settings.obj_face_export_mode.desc": "Ви можете дозволити експортеру OBJ перетворити всі грані на три- або чотирикутники",
	"settings.obj_face_export_mode.both": "Усталено",
	"settings.obj_face_export_mode.tris": "Перетворити на трикутники",
	"settings.obj_face_export_mode.quads": "Перетворити на чотирикутники",
	"action.seam_tool": "Шов",
	"action.seam_tool.desc": "Інструмент для визначення швів UV на ребрах сітки",
	"action.resolve_group": "Розв’язати групу",
	"action.resolve_group.desc": "Розв’язати групу, залишивши її дочірні елементи на тому ж місці",
	"action.move_to_group": "Перемістити до групи",
	"action.move_to_group.desc": "Перемістити виділені елементи до іншої групи у планувальнику",
	"action.select_seam": "Вибрати шов UV",
	"action.select_seam.desc": "Виберіть режим шва UV для виділених ребер",
	"action.select_seam.auto": "Авто",
	"action.select_seam.join": "Приєднати",
	"action.select_seam.divide": "Розділити",
	"action.adjust_brightness_contrast": "Регулювати яскравість і контрастність...",
	"action.adjust_brightness_contrast.desc": "Регулювати яскравість і контрастність вибраної текстури",
	"action.adjust_saturation_hue": "Регулювати насиченість і відтінок...",
	"action.adjust_saturation_hue.desc": "Регулювати насиченість та відтінок вибраної текстури",
	"action.invert_colors": "Інвертувати кольори",
	"action.invert_colors.desc": "Інвертувати всі кольори вибраної текстури",
	"action.adjust_curves": "Налаштувати криві...",
	"action.adjust_curves.desc": "Налаштувати криві яскравості вибраної текстури",
	"action.flip_texture_x": "Перевернути горизонтально",
	"action.flip_texture_y": "Перевернути вертикально",
	"action.resize_texture": "Змінити розмір текстури...",
	"action.view_mode.uv": "Перегляд UV",
	"action.append_to_template": "Додати елементи до шаблону...",
	"action.append_to_template.desc": "Додати вибрані елементи до шаблону текстури",
	"action.move_texture_with_uv": "Перемістити текстуру з UV",
	"action.move_texture_with_uv.desc": "Перемістити текстуру грані вздовж під час перетягування UV грані",
	"action.timeline_setups": "Налаштування часової шкали",
	"action.save_timeline_setup": "Зберегти налаштування часової шкали...",
	"action.save_timeline_setup.desc": "Зберегти шаблон для вибраних аніматорів і каналів",
	"menu.texture": "Текстура",
	"menu.texture.render_mode.default": "Усталений",
	"menu.texture.merge_onto_texture": "Об’єднати з текстурою вище",
	"menu.animation.unload": "Вивантажити",
	"panel.timeline": "Часова шкала",
	"action.pan_tool": "Pan Tool",
	"action.pan_tool.desc": "Інструмент для навігації у вікні перегляду та редакторі текстур",
	"mode.start.recent.favorite": "Позначити як обране",
	"mode.start.info": "Інформація",
	"mode.start.target": "Ціль",
	"mode.start.start": "Розпочати",
	"mode.start.create_new": "Створити нову модель",
	"mode.start.format.informations": "Добре знати:",
	"mode.start.format.resources": "Ресурси:",
	"format.free.info.meshes": "У цьому форматі ви можете створювати низькополігональні моделі, використовуючи куби та сітки власної форми.",
	"format.free.info.limitation": "Моделі не можна завантажувати в ігри, які потребують спеціалізованих форматів, наприклад, Minecraft.",
	"format.skin.info.skin": "Цей формат призначений для створення скінів Minecraft та текстур сутностей.",
	"format.skin.info.model": "Модель не може бути змінена. Аби внести зміни до моделі, спочатку перетворіть її в інший формат через **Файл** > **Перетворити проєкт**.",
	"format.java_block.info.rotation": "Оберти обмежені у 22,5 градуса та однією віссю на елемент",
	"format.java_block.info.size": "Модель обмежена розміром 3x3x3 блоки. Однак налаштування показу може зробити моделі предметів більшими.",
	"format.java_block.info.animation": "Цей формат не підтримує анімацію у ванільній версії Minecraft. Якщо ви створюєте мод, ви можете використовувати GeckoLib для анімації моделей. Якщо ні, то єдиний спосіб анімувати — це перемикати модель за допомогою команд або анімованих текстур.",
	"format.bedrock.info.textures": "Кожна модель може мати лише одну текстуру",
	"format.bedrock_block": "Блок Bedrock",
	"format.bedrock_block.desc": "Модель блоку для Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "Розмір окремих кубів обмежений цілими числами.",
	"format.modded_entity.info.format": "Моделі написані в Java коді, а не в спеціальних структурах даних, як у всіх інших форматах експорту Blockbench.",
	"format.optifine_entity.info.optifine_required": "Користувачі без встановленого OptiFine не побачать модель.",
	"format.optifine_entity.info.pivots": "Центр повороту кісток заблокований, тому краще залишити його недоторканими.",
	"format_category.low_poly": "Низько полімерний",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Інше",
	"format_category.loaders": "Завантажувачі",
	"message.recover_backup.recover": "Відновити",
	"message.invalid_characters.title": "Недійсний шлях",
	"message.invalid_characters.message": "Шлях до імпортованого файлу містить недійсні символи, великі літери або пробіли. Дозволено лише наступні символи: %0",
	"dialog.share_model.thumbnail": "Ескіз",
	"dialog.skin.high_res_texture": "Зверніть увагу, що скіни з вибраною роздільністю не працюватимуть як звичайні скіни Minecraft. Оберіть нижчу роздільність.",
	"settings.allow_display_slot_mirror": "Дозволити віддзеркалення комірки показу",
	"settings.allow_display_slot_mirror.desc": "Дозволити віддзеркалення комірок показу для моделей предметів Java. УВАГА: це працює лише в Minecraft 1.14 або раніше, або в особливих випадках.",
	"action.switch_tabs": "Перемикнути вкладки",
	"action.switch_tabs.desc": "Перехід між відкритими вкладками. Утримуйте Shift для протилежного напрямку.",
	"action.unselect_all": "Зняти всі виділення",
	"action.save_palette": "Зберегти палітру...",
	"action.save_palette.desc": "Зберегти поточну палітру кольорів у Blockbench для подальшого використання",
	"action.keyframe_column_create": "Створити стовпчик кадрів",
	"action.keyframe_column_create.desc": "Закріпити всі канали в часовій шкалі на поточному таймкоді, якщо для них є кадри",
	"action.keyframe_column_select": "Вибрати стовпчик кадрів",
	"action.keyframe_column_select.desc": "Виділити всі кадри у часовій шкалі у стовпчику під відтворення",
	"menu.uv": "UV",
	"menu.keyframe": "Кадр",
	"menu.palette.load.update": "Оновити палітру",
	"menu.palette.load.update.desc": "Оновлює цю палітру кольорами поточної палітри Blockbench",
	"menu.timeline_marker.set_time": "Задати час...",
	"uv_editor.scale_uv": "Масштаб UV",
	"action.preview_scene": "Сцена перегляду",
	"action.preview_scene.desc": "Змінити сцену перегляду моделі",
	"preview_scene.minecraft_overworld": "Верхній світ",
	"preview_scene.minecraft_nether": "Незер",
	"preview_scene.minecraft_end": "Енд",
	"dialog.project.modded_entity_flip_y": "Перевернути вісь Y",
	"preview_scene.studio": "Студія",
	"format.image": "Зображення",
	"modifier_actions.set_copy_source": "Задати джерело копії",
	"message.load_images.title": "Завантажити зображення",
	"message.load_images.edit_image": "Редагувати зображення",
	"dialog.add_primitive.align_edges": "Вирівняти ребра",
	"dialog.flip_animation.show_in_timeline": "Показати змінені кістки на часовій шкалі",
	"settings.default_cube_size": "Розмір куба",
	"settings.default_cube_size.desc": "Усталений розмір куба при створенні нового куба",
	"settings.uniform_keyframe": "Кадри рівномірного масштабу",
	"settings.uniform_keyframe.desc": "Установити усталене рівномірне масштабування кадрів",
	"settings.nearest_rectangle_select": "Виділення прямокутника: найближче ребро",
	"settings.nearest_rectangle_select.desc": "Прив’язувати прямокутні виділення до найближчого пікселя ребра, як у GIMP, а не до цілих пікселів.",
	"settings.pick_color_opacity": "Вибирати непрозорість кольору",
	"settings.pick_color_opacity.desc": "Вибирати непрозорість кольору з піпеткою і задати її як непрозорість пензля",
	"settings.paint_with_stylus_only": "Малювати лише зі стилусом",
	"settings.paint_with_stylus_only.desc": "Використовувати стилус лише для малювання, а мишу або сенсорне введення залишити для навігації.",
	"action.copy_brush_mode": "Режим пензля копіювання",
	"action.copy_brush_mode.copy": "Копіювати",
	"action.copy_brush_mode.pattern": "Візерунок",
	"action.copy_brush_mode.sample": "Зразок",
	"action.brush_shape": "Форма пензля",
	"action.brush_shape.square": "Квадрат",
	"action.brush_shape.circle": "Коло",
	"action.blend_mode": "Режим змішування",
	"action.blend_mode.default": "Усталений",
	"action.blend_mode.set_opacity": "Задати непрозорість",
	"action.blend_mode.color": "Колір",
	"action.blend_mode.behind": "Позаду",
	"action.blend_mode.multiply": "Множення",
	"action.blend_mode.divide": "Розділити",
	"action.blend_mode.add": "Додати",
	"action.blend_mode.subtract": "Віднімати",
	"action.blend_mode.screen": "Екран",
	"action.blend_mode.overlay": "Накладення",
	"action.blend_mode.hard_light": "Жорстке світло",
	"action.blend_mode.difference": "Відмінність",
	"action.copy_brush": "Пензель копіювання",
	"action.copy_brush.desc": "Пензель для копіювання частин текстури або малювання візерунків. Утримуючи Ctrl, клацніть, щоб вибрати джерело копіювання.",
	"action.validator_window": "Переглянути проблеми моделі...",
	"action.validator_window.desc": "Відкриває засіб перевірки, який містить список проблем із поточною моделлю.",
	"action.cancel_gif": "Скасувати GIF",
	"menu.text_edit.copy_vector": "Копіювати вектор",
	"menu.brush_presets.dialog": "Шаблони пензля...",
	"menu.brush_presets.pixel_brush": "Піксельний пензель",
	"menu.brush_presets.smooth_brush": "Гладкий пензель",
	"menu.texture.edit_in_blockbench": "Редагувати у Blockbench",
	"menu.mirror_painting.axis": "Вісь",
	"menu.mirror_painting.axis.desc": "Оберіть, на якій осі штрихи фарби будуть віддзеркалені",
	"menu.mirror_painting.global": "Глобальна симетрія",
	"menu.mirror_painting.global.desc": "Увімкнути дзеркальне малювання моделі в глобальному просторі",
	"menu.mirror_painting.local": "Локальна симетрія",
	"menu.mirror_painting.local.desc": "Увімкнути дзеркальне малювання кожного елемента у локальному просторі",
	"menu.mirror_painting.texture_frames": "Повторювати на кадрах перегортання",
	"menu.mirror_painting.texture_frames.desc": "Віддзеркалити штрихи фарби до кожного кадру анімованих текстур",
	"format.bedrock_block.info.size_limit": "Розмір загального розміру блоку обмежений 30 пікселями у всіх вимірах. Обмеження може бути зміщено від центру в усіх напрямках на 7 пікселів від центру блоку.",
	"format.bedrock_block.info.textures": "Кілька текстур можуть бути застосовані до різних кубів у Blockbench, але для коректної роботи в грі вони потребують додаткових налаштувань у пакеті поведінки.",
	"format.image.desc": "Редагування зображень у 2D-редакторі зображень",
	"generic.delete_all": "Видалити все",
	"message.child_model_only.open": "Відкрити батьк. елемент",
	"message.child_model_only.open_with_textures": "Відкрити батьк. елемент та прийняти текстури",
	"dialog.project.credit": "Автори",
	"dialog.convert_project.create_copy": "Створити копію",
	"dialog.texture.frame_time": "Тривалість кадру",
	"dialog.texture.frame_time.desc": "Задати, як довго буде видно кожен кадр, у тиках. Кожен тик — це 1/20 секунди.",
	"dialog.texture.frame_interpolate": "Інтерполювати",
	"dialog.texture.frame_interpolate.desc": "Інтерполювати між кадрами анімації шляхом перехресного зникання до наступного кадру",
	"dialog.texture.frame_order_type": "Режим циклу",
	"dialog.texture.frame_order_type.loop": "Повторити",
	"dialog.texture.frame_order_type.backwards": "Повторити назад",
	"dialog.texture.frame_order_type.back_and_forth": "Уперед-назад",
	"dialog.texture.frame_order_type.custom": "Власний порядок",
	"dialog.texture.frame_order": "Порядок рамкок",
	"dialog.texture.frame_order.desc": "Задати власний порядок рамок, перерахувавши індекси рамок у новому порядку. Індекси рамок починаються з 0, починаючи з першого рамки.",
	"dialog.select.mode": "Режим",
	"dialog.select.mode.new": "Нове виділення",
	"dialog.select.mode.add": "Додати до вибраних",
	"dialog.select.mode.remove": "Вилучити з вибраних",
	"dialog.select.mode.in_selection": "Вибрати лише з вибраних",
	"dialog.predicate_overrides.model": "Модель",
	"dialog.predicate_overrides.predicates": "Предикати",
	"dialog.predicate_overrides.variants": "Варіанти",
	"dialog.predicate_overrides.start_value": "Початкове значення",
	"dialog.predicate_overrides.add_override": "Додати перевизначення",
	"dialog.predicate_overrides.add_predicate": "Додати предикат",
	"dialog.predicate_overrides.generate_overrides": "Генерувати перевизначення",
	"dialog.predicate_overrides.confirm_delete": "Ви дійсно бажаєте видалити всі перевизначення?",
	"dialog.predicate_overrides.predicate.angle": "Кут компаса",
	"dialog.predicate_overrides.predicate.blocking": "Is Blocking",
	"dialog.predicate_overrides.predicate.broken": "Is Broken",
	"dialog.predicate_overrides.predicate.cast": "Is Cast",
	"dialog.predicate_overrides.predicate.cooldown": "Cooldown",
	"dialog.predicate_overrides.predicate.damage": "Damage",
	"dialog.predicate_overrides.predicate.damaged": "Is Damaged",
	"dialog.predicate_overrides.predicate.lefthanded": "Is Left-Handed",
	"dialog.predicate_overrides.predicate.pull": "Pull Amount",
	"dialog.predicate_overrides.predicate.pulling": "Is Pulling",
	"dialog.predicate_overrides.predicate.charged": "Is Charged",
	"dialog.predicate_overrides.predicate.firework": "Has Firework",
	"dialog.predicate_overrides.predicate.throwing": "Ready to Throw",
	"dialog.predicate_overrides.predicate.time": "Time of Day",
	"dialog.predicate_overrides.predicate.custom_model_data": "Custom Model Data",
	"dialog.predicate_overrides.predicate.level": "Рівень освітлення",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",
	"settings.model_export_scale": "Розмір експорту моделі",
	"settings.model_export_scale.desc": "Коефіцієнт, з яким зменшується розмір експортованих моделей glTF, DAE та FBX. Усталене значення — 16, що перетворює 16 одиниць Blockbench в 1 метр при експорті.",
	"action.export_fbx": "Експортувати модель FBX",
	"action.export_fbx.desc": "Експортувати модель й анімації як файл FBX для використання його в інших 3D-застосунках та ігрових рушіях",
	"action.center_lateral": "Center Lateral",
	"action.center_lateral.desc": "Center the selected elements on the X and Z axis",
	"action.adjust_opacity": "Регулювати непрозорість...",
	"action.adjust_opacity.desc": "Регулювати непрозорість вибраної текстури",
	"action.rotate_texture_cw": "Обертати за годинниковою стрілкою",
	"action.rotate_texture_ccw": "Обертати проти годинникової стрілки",
	"action.predicate_overrides": "Редагувати перевизначення предикатів...",
	"action.predicate_overrides.desc": "Оберіть моделі для заміни цієї моделі на основі вибраних умов",
	"action.auto_set_cullfaces": "Задати відсікання автоматично",
	"action.auto_set_cullfaces.desc": "Автоматично генерувати відсікання, щоб приховати грані, коли вони закриті сусіднім блоком.",
	"menu.texture.edit_externally": "Редагувати ззовні",
	"menu.mirror_painting.texture": "Симетрія 2D-редактора",
	"menu.mirror_painting.texture.desc": "Увімкнути дзеркальне малювання у 2D просторі на зображенні або текстурі",
	"menu.animator.rotation_global": "Обернути в глобальному просторі",
	"uv_editor.face_properties": "Властивості грані",
	"uv_editor.face_properties.material_instance": "Примірник матеріалу",
	"uv_editor.tint.info": "Тінь можна увімкнути на грані, щоб сказати Minecraft зробити на ній тінь. У ванілі тінь може бути використана лише для певних блоків, таких як листя та пил редстоуну, і може мати лише значення 0.",
	"uv_editor.cullface.info": "Увімкнення відсікання вказує грані на блоці зняти візуалізацію, якщо поруч з ним у вказаному напрямку у вашому світі Minecraft буде розміщено інший повний блок. Це може бути використано для оптимізації швидкодії.",
	"uv_editor.material_instance.info": "Екземплярам матеріалів можна присвоїти назву. Цю назву можна використовувати у файлі блоку JSON в пакеті поведінки, щоб призначити певну текстуру та матеріал для грані.",
	"display.reference.frame_invisible": "Рамка (Невидима)",
	"data.settings_profile": "Профіль",
	"message.display_skin.invalid_name": "Не вдається знайти обл. запис Minecraft з іменем «%0».",
	"dialog.load_plugins_from_query.title": "Завантажити плагіни",
	"dialog.load_plugins_from_query.text": "Ви скористалися посиланням, яке вимагає встановлення плагінів. Бажаєте їх встановити?",
	"dialog.select_model.title": "Оберіть модель",
	"dialog.select_model.bones": "Кістки",
	"dialog.select_model.cubes": "Куби",
	"dialog.settings.create_profile": "Створити профіль...",
	"settings_profile.confirm_delete": "Ви дійсно бажаєте видалити цей профіль налаштувань?",
	"settings_profile.condition.type.selectable": "Вибір уручну",
	"settings.interface_mode": "Режим ІК",
	"settings.interface_mode.desc": "Режим інтерфейсу",
	"settings.interface_mode.auto": "Автоматично",
	"settings.interface_mode.desktop": "Настільний",
	"settings.interface_mode.mobile": "Мобільний",
	"settings.paint_through_transparency": "Малювати крізь прозорість",
	"settings.paint_through_transparency.desc": "Малювати через прозорі пікселі, коли ввімкнено блокування альфа-каналу",
	"action.tab_overview": "Огляд вкладки",
	"action.tab_overview.desc": "Переглянути всі відкриті вкладки в сітці та перейти до однієї",
	"action.slider_color_red": "Червоний колір",
	"action.slider_color_green": "Зелений колір",
	"action.slider_color_blue": "Синій колір",
	"action.add_animation_controller": "Додати контролер анімації",
	"action.add_animation_controller.desc": "Створити порожній контролер анімації",
	"action.animation_controller_preview_mode": "Режим контролера",
	"action.animation_controller_preview_mode.paused": "Призупинено",
	"action.animation_controller_preview_mode.manual": "Вручну",
	"action.animation_controller_preview_mode.play": "Авто. відтворення",
	"action.keyframe_interpolation.bezier": "Безьє",
	"action.keyframe_bezier_linked": "Прив’язати дескриптори Безьє",
	"action.keyframe_bezier_linked.desc": "З’єднати правий та лівий дескриптор Безьє кадра",
	"action.reset_keyframe_handles": "Скинути ручки кадрів",
	"action.reset_keyframe_handles.desc": "Скинути дескриптори Безьє виділених кадрів",
	"action.looped_animation_playback": "Looped Playback",
	"action.looped_animation_playback.desc": "Переглядати анімації у нескінченному циклі",
	"timeline.bind_to_actor": "Прив’язати до актора",
	"animation_controllers.select_preset": "Оберіть шаблон налаштувань контролера...",
	"animation_controllers.state.animations": "Анімації",
	"animation_controllers.state.particles": "Частинки",
	"animation_controllers.state.sounds": "Звуки",
	"animation_controllers.state.on_entry": "При вступі",
	"animation_controllers.state.on_exit": "При виході",
	"animation_controllers.state.transitions": "Переходи",
	"animation_controllers.state.condition": "Умова",
	"animation_controllers.state.blend_transition": "Час змішування",
	"animation_controllers.state.shortest_path": "Змішування за найкоротшим шляхом",
	"animation_controllers.state.edit_transition": "Редагувати перехід",
	"menu.color_picker.picker_type": "Тип піпетки",
	"menu.color_picker.picker_type.square": "Квадрат",
	"menu.color_picker.picker_type.wheel": "Колесо",
	"menu.color_picker.slider_mode": "Режим повзунка",
	"menu.color_picker.slider_mode.hsv": "Відтінок, Насиченість, Значення",
	"menu.color_picker.slider_mode.rgb": "Червоний, Зелений, Синій",
	"menu.texture.render_mode.additive": "Адитивний",
	"panel.color.picker_options": "Параметри піпетки",
	"panel.animation_controllers": "Контролер анімації",
	"display.preset.armor_stand": "Наземний (Стійка для обладунків)",
	"data.file_path": "Шлях до файлу",
	"dialog.extrude.orientation": "Орієнтація",
	"dialog.extrude.orientation.upright": "Вертикальна",
	"dialog.extrude.orientation.flat": "Рівна",
	"dialog.scale.box_uv_warning": "Масштабування коробки UV моделі може призвести до пошкодження UV вашої моделі. Замість цього спробуйте масштабувати модель ззовні, або перемкніться на режим UV для кожної грані у меню «Файл» > «Проєкт».",
	"dialog.create_gif.format": "Формат",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG",
	"dialog.create_gif.pixelate": "Піксельний",
	"dialog.create_gif.bg_image": "Зображення тла",
	"dialog.create_gif.turn.desc": "Rotate the model while recording. Use negative values to turn the model clockwise. A value of 60 corresponds to one rotation every second.",
	"settings_profile.condition": "Умова",
	"settings_profile.condition.type.file_path.desc": "Використовуйте синтаксис регулярних виразів, щоб вказати шлях до файлу поточного проєкту. Вписуйте прямі скісні риски для тек",
	"settings.only_selected_bezier_handles": "Показувати лише виділені дескриптори Безьє",
	"settings.only_selected_bezier_handles.desc": "Приховувати дескриптори Безьє кадрів, які не виділено",
	"settings.embed_textures": "Вбудовувати текстури",
	"settings.embed_textures.desc": "Вбудовувати вміст файлів текстур у файли .bbmodel",
	"action.selection_mode.cluster": "Кластер",
	"dialog.copied_to_clipboard": "Скопійовано до буфера обміну",
	"data.reference_image": "Еталонне зображення",
	"message.delete_reference_image": "Ви дійсно бажаєте видалити це зображення? Дію не можна буде скасувати.",
	"message.add_reference_image.message": "Виберіть, куди завантажити зображення",
	"message.add_reference_image.project": "Додати до цього проєкту",
	"message.add_reference_image.app": "Додати до всіх проєктів",
	"message.import_particle_texture.import": "Імпортувати текстуру частинок",
	"message.import_particle_texture.message": "Бажаєте імпортувати файл текстури, який буде використано для ваших частинок?",
	"message.save_codec_selector.title": "Зберегти формат моделі",
	"message.save_codec_selector.message": "Оберіть формат для збереження моделі.",
	"message.save_codec_selector.project_file": "Проєкт Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Обидва",
	"message.display_skin.username": "Ім’я користувача (Java)",
	"message.palette_locked": "Палітра заблокована",
	"dialog.project.default_uv_mode": "Усталений режим UV",
	"dialog.project.default_uv_mode.description": "Стандартний режим UV для проєкту. Режим UV також можна змінити для кожного куба.",
	"dialog.export_options.title": "Параметри експорту",
	"dialog.edit_texture.preview": "Перегляд",
	"dialog.proportional_editing.range": "Діапазон",
	"dialog.proportional_editing.falloff": "Опадання",
	"dialog.proportional_editing.falloff.linear": "Лінійний",
	"dialog.proportional_editing.falloff.hermite_spline": "Гладкий",
	"dialog.proportional_editing.falloff.constant": "Постійний",
	"dialog.proportional_editing.selection": "Вибір",
	"dialog.proportional_editing.selection.linear": "Лінійна відстань",
	"dialog.proportional_editing.selection.connections": "З’єднання",
	"dialog.mirror_painting_texture_center.middle": "Середина",
	"dialog.mirror_painting_texture_center.custom": "Власний",
	"dialog.settings.reset_to_default": "Скинути до типових",
	"keybindings.item.num_slider.increase": "Збільшити",
	"keybindings.item.num_slider.decrease": "Зменшити",
	"settings.always_show_splash_art": "Завжди показувати заставку",
	"settings.always_show_splash_art.desc": "Завжди відображати заставку на початковому екрані",
	"action.slider_palette_color": "Колір палітри",
	"action.slider_palette_color.desc": "Перемикнути колір у палітрі",
	"action.proportional_editing": "Редагування пропорцій",
	"action.proportional_editing.desc": "Пропорційно впливати на навколишні вершини під час редагування частин меша",
	"action.limit_to_palette": "Limit to Palette",
	"action.limit_to_palette.desc": "Обмежує кольори текстури тими, що є у поточній завантаженій палітрі",
	"action.edit_reference_images": "Редагувати зображення",
	"action.edit_reference_images.desc": "Увімкнути режим зображення, щоб додавати або редагувати зображення та креслення",
	"action.add_reference_image": "Додати зображення",
	"action.reference_image_from_clipboard": "Зображення з буфера обміну",
	"action.reference_image_list": "Зображення",
	"action.connect_uv_faces": "З’єднати UV грані",
	"action.connect_uv_faces.desc": "З’єднати виділені UV грані з останньою виділеною UV гранню",
	"action.merge_uv_vertices": "Об’єднати UV вершини",
	"action.merge_uv_vertices.desc": "Прив’язати перші виділені UV вершини до останніх виділених UV вершин",
	"action.bedrock_animation_mode": "Режим анімації Bedrock",
	"action.bedrock_animation_mode.desc": "Вибрати режим редагування анімацій для Minecraft: Bedrock Edition",
	"action.bedrock_animation_mode.entity": "Сутність",
	"action.bedrock_animation_mode.attachable_first": "Предмет від 1-ї особи",
	"action.bedrock_animation_mode.attachable_third": "Предмет від 3-ї особи",
	"timeline.amplify": "Посилити",
	"menu.options": "Параметри...",
	"menu.palette.lock_palette": "Блокувати палітру",
	"menu.uv.export": "Експорт UV мапування",
	"menu.uv.flip_x": "Віддзеркалити по X",
	"menu.uv.flip_y": "Віддзеркалити по Y",
	"menu.mirror_painting.enabled": "Увімкнено",
	"reference_image.position": "Позиція",
	"reference_image.size": "Розмір",
	"reference_image.rotation": "Обертання",
	"reference_image.opacity": "Непрозорість",
	"reference_image.visibility": "Видимість",
	"reference_image.clear_mode": "Режим очищення",
	"reference_image.layer": "Шар",
	"reference_image.layer.background": "Позаду моделі",
	"reference_image.layer.viewport": "Над моделлю",
	"reference_image.layer.float": "Над інтерфейсом",
	"reference_image.scope": "Область",
	"reference_image.scope.project": "Саме цей проєкт",
	"reference_image.scope.global": "Усі проєкти",
	"reference_image.enabled_modes": "Увімкнено в режимах",
	"codec.common.encoding": "Кодування",
	"codec.common.armature": "Експорт груп як скелет",
	"codec.common.export_animations": "Експортувати анімації",
	"codec.common.embed_textures": "Вбудувати текстури",
	"preview.center_camera": "Відцентрувати камеру",
	"display.reference.frame_top": "Верх рамки",
	"display.reference.frame_top_invisible": "Верх рамки (невидима)",
	"action.proportional_editing_range": "Діапазон пропорційного редагування",
	"action.proportional_editing_range.desc": "Регулювання діапазону пропорційного редагування",
	"action.toggle_all_reference_images": "Приховати/показати всі зображення",
	"action.toggle_all_reference_images.desc": "Перемкнути видимість усіх зображень одночасно",
	"action.add_animation_controller_state": "Додати стан контролера анімації",
	"action.add_animation_controller_state.desc": "Додати новий стан до контролера анімації",
	"menu.slider.round_value": "Ціле значення",
	"texture.error.too_large": "Роздільність перевищує максимум %0",
	"dialog.copy_to_clipboard": "Копіювати до буфера обміну",
	"dialog.open_url": "Відкрити посилання",
	"reference_image.image": "Зображення",
	"uv_editor.rotate_uv": "Обертати UV",
	"generic.error": "Помилка",
	"projects.start_screen": "Початковий екран",
	"message.invalid_link.message": "Спільна модель «%0», яку ви намагаєтеся завантажити, є недійсною або застарілою.",
	"message.plugin_dependencies.title": "Залежності плагіна",
	"message.plugin_dependencies.message1": "Для роботи плагіна потрібні ці залежності:",
	"message.plugin_dependencies.message1_update": "Плагін %0 було оновлено, і тепер йому потрібні ці залежності:",
	"message.plugin_dependencies.message2": "Бажаєте встановити їх, щоб продовжити?",
	"message.plugin_dependencies.invalid": "На жаль, плагін не може бути встановлений, він має недійсну залежність:",
	"message.preview_scene_load_failed": "Не вдалося завантажити сцену перегляду. Перевірте підключення до Інтернету.",
	"dialog.convert_project.text1": "Конвертувати проєкт в інший формат.",
	"dialog.convert_project.text2": "Використовуйте конвертацію на свій страх і ризик. Формати мають різні особливості та обмеження, тому в деяких випадках конвертація може порушити роботу частин вашого проєкту.",
	"dialog.convert_project.text3": "Ви не зможете скасувати конвертацію, тому за стандартом буде створено копію.",
	"dialog.unsaved_work.title": "Незбережена робота",
	"dialog.unsaved_work.text": "Наступні проєкти містять незбережені зміни. Бажаєте зберегти зміни?",
	"dialog.unsaved_work.discard_all": "Відкинути все",
	"dialog.unsaved_work.save_all": "Зберегти все",
	"dialog.resize_texture.mode": "Режим",
	"dialog.resize_texture.mode.crop": "Згорнути/розгорнути",
	"dialog.resize_texture.mode.scale": "Масштаб",
	"dialog.plugins.is_installed": "Установлено",
	"dialog.plugins.is_disabled": "Вимкнуто",
	"dialog.plugins.disable": "Вимкнути",
	"dialog.plugins.enable": "Увімкнути",
	"dialog.plugins.dependencies": "Залежить від:",
	"dialog.view_backups.open_folder": "Відкрити теку",
	"dialog.share_model.reference_images": "Включати зображення",
	"dialog.share_model.too_large": "Не вдалося вивантажити: модель завелика",
	"dialog.share_model.too_large_references": "Не вдалося вивантажити: модель завелика. Спробуйте без зображень.",
	"settings.stretch_linked": "Розтягування зв’язків",
	"settings.stretch_linked.desc": "Розтягувати куб у всіх напрямках на однакову величину",
	"settings.grids": "Показувати сітки",
	"settings.grids.desc": "Показувати або приховувати всі 3D сітки",
	"settings.double_click_switch_tools": "Перемикати інструменти подвійним натисканням",
	"settings.double_click_switch_tools.desc": "Двічі натиснути вікно перегляду для перемикання між інструментами",
	"settings.outlines_in_paint_mode": "Контури виділення у режимі малювання",
	"settings.outlines_in_paint_mode.desc": "Показувати контури виділення елементів у режимі малювання",
	"settings.json_indentation": "Відступ JSON",
	"settings.json_indentation.desc": "Стиль відступів для експортованих файлів JSON",
	"settings.json_indentation.tabs": "Знаки табуляції",
	"settings.json_indentation.spaces_4": "Пробіли: 4",
	"settings.json_indentation.spaces_2": "Пробіли: 2",
	"action.slider_stretch": "Розтягнути",
	"action.slider_stretch.desc": "Розтягує куби множинно по осі %0 без зміни UV",
	"action.view_backups": "Проглянути резервні копії",
	"action.view_backups.desc": "Переглянути список автоматично збережених резервних копій проєкту",
	"action.search_outliner": "Пошук у планувальнику",
	"action.search_outliner.desc": "Пошук конкретних назв елементів у планувальнику",
	"action.mirror_modeling": "Дзеркальне моделювання",
	"action.mirror_modeling.desc": "Увімкнути дзеркальне моделювання по осі X. Усі зміни, які ви робите в області перегляду, показуватимуться на іншій стороні, якщо лише для елемента не буде спеціально вимкнено цей параметр.",
	"action.allow_element_mirror_modeling": "Дозволити дзеркальне моделювання",
	"action.allow_element_mirror_modeling.desc": "Виберіть, чи впливатиме дзеркальне моделювання на виділені елементи",
	"action.switch_face_crease": "Перемкнути складку грані",
	"action.switch_face_crease.desc": "Перемикач напрямку складки чотирикутників посередині",
	"action.clear_unused_texture_space": "Очистити невикористаний простір текстури",
	"action.clear_unused_texture_space.desc": "Очистити частини текстури, які не мають UV мапування до жодних елементів",
	"action.split_screen": "Розділити екран",
	"action.split_screen.desc": "Вибрати режим розділення екрана для вікна перегляду",
	"action.split_screen.single": "Окремо",
	"action.split_screen.double_horizontal": "Подвійний горизонтально",
	"action.split_screen.double_vertical": "Подвійний вертикально",
	"action.split_screen.quad": "Чотири",
	"action.split_screen.triple_left": "Три ліворуч",
	"action.split_screen.triple_right": "Три праворуч",
	"action.split_screen.triple_top": "Три зверху",
	"action.split_screen.triple_bottom": "Три знизу",
	"action.uv_project_from_view": "UV проєкту з вигляду",
	"action.uv_project_from_view.desc": "Автоматично генерувати UV для виділених граней з перспективи 3D вигляду",
	"action.graph_editor_other_graphs": "Показати інші графіки",
	"action.graph_editor_other_graphs.desc": "Чи відображати графіки осей, які не вибрано",
	"action.graph_editor_include_other_graphs": "Включити інші графіки",
	"action.graph_editor_include_other_graphs.desc": "Чи включає графічний редактор графіки, які не вибрано у поданні",
	"action.set_ik_source": "Задати корінь IK",
	"action.set_ik_source.desc": "Вибрати кореневу кістку ланцюга, яку має перемістити цей порожній об’єкт, за допомогою Інверсної кінематики",
	"edit.loop_cut.cuts": "Вирізи",
	"panel.element.stretch": "Розтягнути",
	"preview_scene.minecraft_plains": "Рівнини",
	"preview_scene.minecraft_cherry_grove": "Вишневий гай",
	"preview_scene.minecraft_snowy_tundra": "Снігова тундра",
	"preview_scene.minecraft_sunset": "Захід сонця",
	"preview_scene.minecraft_night": "Ніч",
	"preview_scene.minecraft_desert": "Пустеля",
	"preview_scene.minecraft_underwater": "Під водою",
	"preview_scene.minecraft_coral_reef": "Кораловий риф",
	"preview_scene.minecraft_lush_cave": "Густа печера",
	"preview_scene.minecraft_deep_dark": "Глибока темрява",
	"generic.navigate_forward": "Уперед",
	"generic.navigate_back": "Назад",
	"action.element_render_order": "Порядок візуалізації прозорості",
	"action.element_render_order.default": "Авто.",
	"action.element_render_order.behind": "Позаду",
	"action.element_render_order.in_front": "Попереду",
	"message.installing_update.title": "Доступно оновлення",
	"message.installing_update.message": "Нова версія готова до встановлення. Після закриття застосунка, будь ласка, зачекайте близько %0 сек, перш ніж знову відкривати Blockbench або вимикати пристрій, поки оновлення не буде встановлено.",
	"settings.brush_cursor_2d": "2D вказівник пензля",
	"settings.brush_cursor_2d.desc": "Показувати контур навколо пензля у 2D робочій області",
	"settings.brush_cursor_3d": "3D вказівник пензля",
	"settings.brush_cursor_3d.desc": "Показувати контур навколо пензля у 3D робочій області",
	"settings.cdn_mirror": "Використовувати дзеркало CDN",
	"settings.cdn_mirror.desc": "Використовувати дзеркало CDN для завантаження плагінів. Дзеркало швидше отримує оновлення і працює в деяких регіонах, де не працює за стандартом.",
	"data.layer": "Шар",
	"data.panel": "Панель",
	"generic.confirm_delete": "Ви дійсно бажаєте видалити це?",
	"format_category.general": "Загальний",
	"modifier_actions.no_uniform_scaling": "Вільне масштабування",
	"message.texture_refresh_conflict.title": "Конфліктуючі версії текстур",
	"message.texture_refresh_conflict.message": "Файл текстури може містити зміни, які конфліктують з версією Blockbench",
	"message.texture_refresh_conflict.keep_ours": "Зберегти версію Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "Завантажити файл і відкинути всі зміни та шари в Blockbench",
	"message.group_required_to_animate": "Цей тип елементів не можна анімувати. Створіть групу чи скелет, щоб анімувати його.",
	"dialog.texture.uv_size": "Розмір UV",
	"dialog.advanced_screenshot.angle_preset": "Шаблони кутів",
	"dialog.advanced_screenshot.resolution": "Роздільність",
	"dialog.advanced_screenshot.zoom_to_fit": "Підігнати масштаб",
	"dialog.advanced_screenshot.zoom": "Масштаб / Фокусна відстань",
	"dialog.advanced_screenshot.anti_aliasing": "Згладжування",
	"dialog.advanced_screenshot.anti_aliasing.off": "Вимк.",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Мультивибірка",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Супервибірка",
	"dialog.advanced_screenshot.show_gizmos": "Показ інструментів редагування",
	"dialog.advanced_screenshot.shading": "Тіні",
	"settings.auto_keyframe": "Автоматичний кадр",
	"settings.auto_keyframe.desc": "Автоматично створювати кадр з усталеними значенням на початку часової шкали під час переміщення кістки в пізнішій точці",
	"settings.modded_entity_integer_size": "Розмір модифікованої сутності в цілому числі",
	"settings.modded_entity_integer_size.desc": "Обмежити розмір куба у форматі модифікованої сутності цілими числами. Хоча в деяких версіях технічно підтримуються числа з рухомою крапкою, цілі числа набагато простіше наносити на UV мапу.",
	"category.layers": "Шари",
	"keybind.paint_secondary_color": "Малювати додатковим кольором",
	"action.selection_tool_operation_mode": "Режим роботи виділення",
	"action.selection_tool_operation_mode.create": "Нове виділення",
	"action.selection_tool_operation_mode.add": "Додати до виділення",
	"action.selection_tool_operation_mode.subtract": "Вилучити з виділення",
	"action.selection_tool_operation_mode.intersect": "Перетин",
	"action.pixel_perfect_drawing": "Піксельна точність",
	"action.pixel_perfect_drawing.desc": "Малювати плавні піксельні лінії без подвійних пікселів на кривих",
	"action.selection_tool": "Виділення",
	"action.selection_tool.desc": "Виділити частину зображення",
	"action.selection_tool.rectangle": "Прямокутник",
	"action.selection_tool.ellipse": "Еліпс",
	"action.selection_tool.lasso": "Ласо",
	"action.selection_tool.wand": "Чарівна паличка",
	"action.selection_tool.color": "Той же колір",
	"action.move_layer_tool": "Перемістити шар",
	"action.move_layer_tool.desc": "Перемістити поточний шар або виділення",
	"action.export_modded_animations": "Експорт анімацій модифікованої сутності",
	"action.export_modded_animations.desc": "Експортувати анімації для модифікованої моделі сутності Minecraft Java Edition",
	"action.swap_colors": "Змінити кольори",
	"action.swap_colors.desc": "Поміняти основний колір на другорядний",
	"action.apply_mesh_rotation": "Застосувати обертання",
	"action.apply_mesh_rotation.desc": "Скинути обертання елемента сітки та застосувати його до геометрії натомість",
	"action.flip_texture_x.desc": "Перевернути текстуру або шар горизонтально",
	"action.flip_texture_y.desc": "Перевернути текстуру або шар вертикально",
	"action.rotate_texture_cw.desc": "Обернути текстуру або шар за годинниковою стрілкою",
	"action.rotate_texture_ccw.desc": "Обернути текстуру або шар проти годинникової стрілки",
	"action.crop_texture_to_selection": "Обрізати текстуру до виділеного",
	"action.create_empty_layer": "Створити порожній шар",
	"action.enable_texture_layers": "Увімкнути шари",
	"action.disable_texture_layers": "Вимкнути шари",
	"action.layer_opacity": "Непрозорість шару",
	"action.layer_to_texture_size": "Розширити шар до розміру текстури",
	"action.layer_to_texture_size.desc": "Розширити шар до розміру текстури",
	"action.merge_layer_down": "Об’єднати з низом",
	"action.merge_layer_down.desc": "Об’єднати з шаром нижче",
	"action.advanced_screenshot": "Просунутий знімок екрана...",
	"action.advanced_screenshot.desc": "Зробити зняток моделі з розширеними параметрами",
	"action.bake_ik_animation": "Фіксація зворотної кінематики",
	"action.bake_ik_animation.desc": "Зафіксувати обертання, застосовані зворотною кінематикою, у виділену анімацію",
	"action.save_animation_preset": "Зберегти шаблон анімації...",
	"action.save_animation_preset.desc": "Зберегти виділені кадри як шаблон анімації",
	"action.animation_onion_skin": "Фантом кадрів анімація",
	"action.animation_onion_skin.desc": "Показати каркасний вигляд іншого кадру в анімації для референсу",
	"action.apply_animation_preset": "Застосувати попередню анімацію",
	"action.apply_animation_preset.desc": "Виберіть зі списку шаблонів анімації та застосуйте її до виділеної кістки",
	"menu.brush_presets.pixel_perfect": "Пензель з точністю до пікселя",
	"panel.layers": "Шари",
	"uv_editor.copy_paste_tool.to_layer": "На новий шар",
	"format.image.new": "Створити нове зображення",
	"format.image.info.summary": "Редактор 2D-зображень дає змогу створювати і редагувати зображення та піксельну графіку безпосередньо в Blockbench, без необхідності використання іншого редактора зображень. Редагуйте зображення, змінюйте текстури або створюйте власні піксель-арти!",
	"settings.move_with_selection_tool": "Використовувати інструмент «Виділення» для їх переміщення",
	"settings.move_with_selection_tool.desc": "Дозволити інструменту «Виділення» напряму переміщувати виділення без необхідності перемикатися на інший шар",
	"settings.final_newline": "Останній новий рядок",
	"settings.final_newline.desc": "Вставляти символ нового рядка в кінці експортованих файлів",
	"action.crop_layer_to_selection": "Обрізати шар до виділення",
	"action.edit_mode_uv_overlay.desc": "Показати UV мапу як накладення у режимі редагування",
	"menu.image": "Зображення",
	"menu.texture.discard_changes": "Відкинути зміни",
	"menu.texture.discard_changes.desc": "Відкинути всі незбережені зміни та завантажити останню версію з файлу",
	"panel.textures.images": "Зображення",
	"dialog.advanced": "Розширено",
	"dialog.recommended_option": "рекомендовано",
	"modifier_actions.snap_to_center": "Прив’язати до центру",
	"modifier_actions.snap_to_pixels": "Прив’язати до пікселів",
	"message.invalid_format.install_plugin": "Установити плагін «%0»",
	"message.plugin_deprecated.message": "Ви дійсно бажаєте встановити цей застарілий плагін?",
	"message.plugin_deprecated.install_anyway": "Однаково встановити",
	"message.image_editor.not_found": "Не вдалося знайти зазначений редактор зображень. Будь ласка, виберіть інший варіант.",
	"message.knife_tool.confirm": "Натисніть %0 або клацніть тут для застосування інструменту «Ніж»",
	"message.knife_tool.skipped_face": "Не вдається вирізати між різними гранями. Включіть ребра або вершини між ними!",
	"message.optimize_animation.keyframes_removed": "Видалено зайві кадри (%0)",
	"message.optimize_animation.nothing_to_optimize": "Не знайдено нічого для оптимізації!",
	"message.duplicate_bone_copy_animation.title": "Копія анімації",
	"message.duplicate_bone_copy_animation.message": "Продубльована кістка анімована в анімації %0. Бажаєте скопіювати кадри на нову кістку?",
	"message.auto_fix_mesh_edit.title": "Авто. виправлення",
	"message.auto_fix_mesh_edit.revert": "Повернути редагування",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Деякі вершини були переміщені в одне місце. Як би ви хотіли діяти далі?",
	"message.auto_fix_mesh_edit.concave_quads": "Одна або кілька чотирикутних граней тепер увігнуті, що може спричинити проблеми з UV мапуванням та візуалізацією. Blockbench може автоматично виправити для вас:",
	"message.auto_fix_mesh_edit.merge_vertices": "Об’єднати вершини",
	"message.auto_fix_mesh_edit.split_quads": "Розділити чотирикутники",
	"message.load_images.add_image": "Додати зображення",
	"dialog.project.modded_entity_entity_class": "Клас сутності",
	"dialog.resize_texture.offset": "Зміщення",
	"dialog.animated_texture_editor.code_reference": "Посилання на код",
	"dialog.animated_texture_editor.code_reference.about": "Цей код для реалізації анімації текстури був створений як довідник і не обов’язково працюватиме без змін. Перегляньте документацію, щоб дізнатися більше.",
	"dialog.animated_texture_editor.code_reference.docs": "Документація",
	"dialog.animated_texture_editor.reframe": "Перезняти кадр",
	"dialog.animated_texture_editor.stride": "Розмір кадру",
	"dialog.animated_texture_editor.frames": "Кількість кадрів",
	"dialog.animated_texture_editor.add_frame": "Додати кадр",
	"dialog.animated_texture_editor.resize_frames": "Змінити розмір кадрів...",
	"dialog.animated_texture_editor.apply": "Застосувати",
	"dialog.add_primitive.edge_size": "Розмір ребра",
	"dialog.change_animation_speed.speed": "Швидкість",
	"dialog.change_animation_speed.adjust_snapping": "Налаштувати прив’язку",
	"dialog.optimize_animation.selection": "Виділення",
	"dialog.optimize_animation.selection.selected_keyframes": "Виділені кадри",
	"dialog.optimize_animation.selection.selected_animation": "Виділену анімацію",
	"dialog.optimize_animation.selection.all_animations": "Усі анімації",
	"dialog.optimize_animation.thresholds": "Порогові значення",
	"dialog.import_obj.obj": "Файл OBJ",
	"dialog.import_obj.mtl": "Файл MTL",
	"dialog.import_obj.scale": "Масштаб",
	"layout.thumbnail": "Користувацька мініатюра CSS",
	"settings.pixel_grid": "Піксельна сітка",
	"settings.pixel_grid.desc": "Показувати сітку пікселів текстури на елементах у режимі редагування",
	"settings.image_editor_grid_size": "Розмір сітки у редакторі зображень",
	"settings.image_editor_grid_size.desc": "Розмір великої сітки у 2D редакторі зображень",
	"settings.ground_plane_double_side": "Двостороння площина основи",
	"settings.ground_plane_double_side.desc": "Зробити площину основи видимою знизу",
	"settings.optifine_save_default_texture": "OptiFine JEM: експорт виділеної текстури",
	"settings.optifine_save_default_texture.desc": "Експортувати виділену текстуру як типову текстуру моделі",
	"action.slider_color_select_threshold": "Поріг вибору кольору",
	"action.slider_color_select_threshold.desc": "Наскільки близьким має бути колір сусіднього пікселя для виділення кольором або паличкою виділення",
	"action.stretch_tool": "Розтягнути",
	"action.stretch_tool.desc": "Інструмент для виділення та розтягування елементів",
	"action.knife_tool": "Інструмент «Ніж»",
	"action.knife_tool.desc": "Інструмент для розрізання грань мешу на менші частини",
	"action.duplicate_project": "Дублювати проєкт",
	"action.duplicate_project.desc": "Створює копію відкритого проєкту",
	"action.transform_space.parent": "Батьківський",
	"action.transform_pivot_space": "Простір переміщення точчки оберту",
	"action.solidify_mesh_selection": "Ущільнити грані",
	"action.solidify_mesh_selection.desc": "Ущільнити виділені грані сітки",
	"action.animated_texture_editor": "Анімація перегортання...",
	"action.animated_texture_editor.desc": "Налаштувати або змінити анімацію перегортання виділеної текстури",
	"action.center_individual_pivots": "Відцентрувати окремі точки оберту",
	"action.center_individual_pivots.desc": "Перенести точку оберту кожного виділеного елемента в його центр",
	"action.uv_cycle": "Перемкнути UV",
	"action.uv_cycle.desc": "Пройтися за порядком UV вершин без зміни UV позицій",
	"action.uv_cycle_invert": "Перемкнути інвертування UV",
	"action.uv_cycle_invert.desc": "Змінити порядок UV вершин без зміни UV позицій",
	"action.slider_animation_controller_speed": "Швидкість відтворення контролера",
	"action.slider_animation_controller_speed.desc": "Швидкість відтворення контролерів анімації у відсотках",
	"action.optimize_animation": "Оптимізувати анімацію",
	"action.optimize_animation.desc": "Оптимізувати поточну анімацію та зменшити кількість кадрів",
	"action.change_animation_speed": "Змінити швидкість анімації...",
	"action.change_animation_speed.desc": "Змінити швидкість обраної анімації",
	"timeline.select_particle_file": "Вибрати файл з частинками",
	"timeline.select_sound_file": "Вибрати файл зі звуком",
	"menu.cube.texture.default": "Стандартна",
	"menu.texture.particle.clear": "Припинити використання для частинок",
	"menu.texture.use_as_default": "Установити за стандартом",
	"menu.texture.use_as_default.clear": "Зняти як за стандартом",
	"menu.toolbar.overflow": "Переповнення панелі інструментів",
	"edit.solidify_mesh_selection.thickness": "Товщина",
	"reference_image.sync_to_timeline": "Синхронізувати з часовою шкалою",
	"reference_image.toggle_playback": "Відтворити/зупинити",
	"dialog.add_primitive.shape.beveled_cuboid": "Скошений куб",
	"dialog.ignore_all": "Ігнорувати все",
	"data.texture_group": "Група текстур",
	"data.animation": "Анімація",
	"generic.on": "Увімк.",
	"generic.off": "Вимк.",
	"format.free.info.3d_printing": "3D друк",
	"message.invalid_file.merge_conflict": "Файл містить невирішені конфлікти злиття Git'а.",
	"dialog.expand_texture_selection.radius": "Кількість",
	"dialog.expand_texture_selection.corner": "Форма кута",
	"dialog.expand_texture_selection.corner.round": "Кругла",
	"dialog.expand_texture_selection.corner.square": "Квадратна",
	"dialog.expand_texture_selection.corner.manhattan": "Мангеттен",
	"dialog.merge_animation.merge_target": "Об’єднати",
	"keybindings.variation_conflict": "Варіація конфліктує з основною прив’язкою клавіш",
	"settings.recovery_save_interval": "Інтервал збереження точки відновлення",
	"settings.recovery_save_interval.desc": "Blockbench регулярно зберігає відкритий проєкт у фоновому режимі, щоб відновити його у випадку аварійного завершення роботи пристрою. Інтервал задається у секундах. Для вимкнення збереження, установіть значення 0.",
	"settings.save_view_per_tab": "Зберігати вид у вкладці",
	"settings.save_view_per_tab.desc": "Зберігати поточний кут виду для кожної вкладки окремо",
	"settings.inherit_parent_color": "Успадковувати батьківський колір",
	"settings.inherit_parent_color.desc": "Установити колір маркера новоствореного елемента на батьківський колір замість випадкового кольору",
	"keybind.preview_select.multi_select": "Множинне виділення",
	"keybind.preview_select.group_select": "Групове виділення",
	"keybind.preview_select.loop_select": "Виділення петлі",
	"action.fill_mode.selection": "Виділення",
	"action.fill_mode.selected_elements": "Виділені елементи",
	"action.image_tiled_view": "Плитковий вигляд",
	"action.image_tiled_view.description": "Увімкнути плитковий вигляд у 2D редакторі",
	"action.image_onion_skin_view": "Фантом кадри у редакторі зображень",
	"action.image_onion_skin_view.description": "Увімкнути вигляд фантом кадрів у 2D редакторі",
	"action.expand_texture_selection": "Розширити виділення текстури",
	"action.expand_texture_selection.desc": "Розширити або звузити виділення текстури",
	"action.switch_tabs.reverse_order": "Зворотний порядок",
	"action.save_project_incremental": "Зберегти проєкт з номером",
	"action.save_project_incremental.desc": "Зберігає поточну модель як файл проєкту з послідовним номером (наприклад, project_2.bbmodel)",
	"action.copy.multiple": "Копіювати все",
	"action.copy.multiple.desc": "Скопіювати всі наявні дані окремо",
	"action.paste.multiple": "Вставити все",
	"action.randomize_marker_colors": "Кольори маркера навмання",
	"action.cube_light_emission": "Випромінювання світла",
	"action.cube_light_emission.desc": "Зміна випромінювальної здатності виділених кубів у діапазоні від 0 до 15",
	"action.view_mode.colored_solid": "Суцільні з кольорами маркера",
	"action.focus_on_selection.rotate_only": "Лише обертання",
	"action.create_texture_group": "Створити групу текстур",
	"action.create_texture_group.desc": "Створити групу для текстур",
	"action.uv_maximize.all_faces": "Вплинути на всі грані",
	"action.retarget_animators": "Переналаштувати анімації",
	"action.retarget_animators.desc": "Визначити, який аніматор керує якою кісткою або елементом",
	"action.merge_animation": "Об’єднати анімацію",
	"action.merge_animation.desc": "Об’єднати анімацію в іншу анімацію",
	"action.add_keyframe.reset_values": "З усталеними значеннями",
	"action.set_timeline_range_start": "Задати початок діапазону часової шкали",
	"action.set_timeline_range_start.desc": "Задати початкову точку для користувацького діапазону відтворення у часовій шкалі анімації",
	"action.set_timeline_range_end": "Задати кінець діапазону часової шкали",
	"action.set_timeline_range_end.desc": "Задати кінцеву точку для користувацького діапазону відтворення у часовій шкалі анімації",
	"action.disable_timeline_range": "Вимкнути діапазон часової шкали",
	"action.disable_timeline_range.desc": "Вимкнути користувацький діапазон відтворення у часовій шкалі анімації",
	"menu.texture_group.resolve": "Розв’язати",
	"menu.image_tiled_view.mirrored": "Віддзеркалені ребра",
	"menu.image_onion_skin_view.frame": "Кадри",
	"menu.image_onion_skin_view.frame.last_viewed": "Останній переглянутий кадр",
	"menu.image_onion_skin_view.frame.previous": "Попередній кадр",
	"menu.image_onion_skin_view.frame.next": "Наступний кадр",
	"menu.image_onion_skin_view.frame.both": "Попередній + наступний",
	"menu.image_onion_skin_view.display": "Показ",
	"menu.image_onion_skin_view.display.pixels": "Менші пікселі",
	"menu.image_onion_skin_view.display.transparent": "Прозорий",
	"menu.image_onion_skin_view.above": "Показати зверху",
	"menu.animation.reload": "Перезавантажити",
	"switches.autouv.alt": "Відносно",
	"display.rotation_pivot": "Точка обертання",
	"display.scale_pivot": "Масштабувати точку",
	"display.reference.fox": "Лисиця",
	"display.reference.eating": "Їдження",
	"preview_scene.sky": "Небо",
	"preview_scene.space": "Космос",
	"preview_scene.minecraft_ocean": "Океан",
	"message.import_palette.selection_only": "Лише виділення",
	"dialog.blend_transition_edit.ease_in_out": "Прискорення і сповільнення (%0)",
	"dialog.blend_transition_edit.generate": "Згенерувати...",
	"dialog.blend_transition_edit.generate.learn_more": "Більше інформації та перегляд",
	"dialog.blend_transition_edit.generate.curve": "Тип інтерполяції",
	"dialog.blend_transition_edit.generate.steps": "Кадри",
	"settings.fps_limit": "Обмеження кадрів/с",
	"settings.fps_limit.desc": "Обмеження кількості кадрів на секунду, які візуалізує Blockbench. Фактична частота кадрів обмежена тим, що може відобразити ваш пристрій.",
	"settings.outliner_reveal_on_select": "Розкривати елементи при виділенні",
	"settings.outliner_reveal_on_select.desc": "Розкривати елементи у планувальнику при виділенні",
	"settings.java_export_pivots": "Експорт точок оберту моделей блоків/предметів Java",
	"settings.java_export_pivots.desc": "Зберігати точки оберту у моделях блоків/предметів Java на кубах без обертання",
	"animation_controllers.state.blend_transition_curve": "Крива переходу змішування",
	"menu.slider.reset_vector": "Скинути вектор",
	"dialog.blend_transition_edit.extended": "Розширений графік",
	"message.screenshot_too_large.title": "Проблема з роздільністю знімка екрана",
	"message.screenshot_too_large.message": "Знімок екрана не вдалося успішно зробити. Спробуйте ще раз з меншою роздільністю або без супердискретизації.",
	"message.rename_elements.numbering": "Ви можете користуватися спеціальними символами для генерування порядкових номерів: % для отримання індексу елемента всередині групи, $ для отримання індексу всередині виділення.",
	"generic.edit_externally": "Редагувати ззовні",
	"message.settings_require_restart.title": "Потрібен перезапуск",
	"message.settings_require_restart.message": "Деякі налаштування будуть застосовані лише після перезапуску застосунку.",
	"message.settings_require_restart.restart_now": "Перезапустити",
	"message.settings_require_restart.restart_later": "Пізніше",
	"message.classroom_mode.install_plugin": "Не можна встановити плагіни в режимі класу",
	"dialog.collection.export_path": "Шлях для експорту",
	"dialog.collection.select_all": "Виділити все",
	"dialog.collection.select_none": "Зняти виділення",
	"dialog.collection.add_with_filter": "Додати з фільтром",
	"dialog.collection.remove": "Вилучити",
	"dialog.material_config.title": "Конфігурація матеріалу",
	"dialog.material_config.color_value": "Значення кольору",
	"dialog.material_config.mer": "Металічність—Світність—Шорсткість",
	"dialog.material_config.mer_value": "Значення МСШ",
	"dialog.material_config.depth_type": "Тип глибини",
	"dialog.create_texture.disable_mirror_uv": "Вимкнути віддзеркалення UV",
	"dialog.create_texture.disable_mirror_uv.desc": "Вимкніть параметр «Віддзеркалення UV» у дзеркальному моделюванні задля збереження окремих UV для кожної грані моделі",
	"dialog.create_gif.turn.sync_to_anim_length": "Синхронізувати до довжини анімації",
	"settings.category.controls": "Керування",
	"settings.classroom_mode": "Режим класу",
	"settings.classroom_mode.desc": "Обмежує функціональність, наприклад, встановлення плагінів, і видаляє посилання на соціальні мережі",
	"settings.antialiasing_bleed_fix": "Виправити розмиття при згладжуванні",
	"settings.antialiasing_bleed_fix.desc": "Виправляє розмиття текстур під час використання згладжування",
	"settings.tone_mapping": "Мапування тону",
	"settings.tone_mapping.desc": "Метод наближення для показу високого динамічного діапазону на звичайному екрані для візуалізації PBR.",
	"settings.audio_scrubbing": "Звуковий супровід часової шкали",
	"settings.audio_scrubbing.desc": "Відтворювати короткі прев’ю аудіо під час перегляду на часовій шкалі",
	"settings.viewport_rotate_speed": "Швидкість обертання у вікні перегляду",
	"settings.viewport_rotate_speed.desc": "Чутливість введення при обертанні у вікні перегляду",
	"settings.viewport_zoom_speed": "Швидкість масштабування у вікні перегляду",
	"settings.viewport_zoom_speed.desc": "Чутливість введення при масштабуванні у вікні перегляду",
	"settings.editor_2d_zoom_speed": "Швидкість масштабування у 2D редакторі",
	"settings.editor_2d_zoom_speed.desc": "Чутливість введення при масштабуванні у 2D та UV редакторах",
	"category.select": "Виділити",
	"action.vertex_snap_mode.rotate": "Обернути",
	"action.export_image": "Експортувати зображення",
	"action.export_image.desc": "Експортувати текстуру як файл зображення",
	"action.apply_mirror_modeling": "Застосувати дзеркальне моделювання",
	"action.apply_mirror_modeling.desc": "Застосувати дзеркальне моделювання до виділення. Усі виділені елементи буде скопійовано і перевернуто вздовж осі X.",
	"action.create_collection": "Створити колекцію",
	"action.create_collection.desc": "Створити колекцію з виділення у планувальнику",
	"action.set_collection_content_to_selection": "Зробити виділення вмістом колекції",
	"action.set_collection_content_to_selection.desc": "Зробити виділені групи та елементи як вміст колекції",
	"action.add_to_collection": "Додати виділення до колекції",
	"action.add_to_collection.desc": "Додати виділені групи та елементи до колекції",
	"action.view_mode.material": "Перегляд матеріалу",
	"action.create_material": "Створити матеріал",
	"action.create_material.desc": "Створити новий матеріал PBR з вибраної текстури",
	"action.generate_pbr_map": "Згенерувати мапу PBR...",
	"action.generate_pbr_map.desc": "Згенерувати мапу PBR (мапу висот або мапу металевості, світності, шорсткості) з наявної текстури",
	"menu.tools.main_tools": "Інструменти",
	"menu.view.panels": "Панелі",
	"menu.texture.pbr_channel": "Канал PBR",
	"menu.texture.pbr_channel.color": "Колір",
	"menu.texture.pbr_channel.normal": "Нормаль",
	"menu.texture.pbr_channel.height": "Висота",
	"menu.texture.pbr_channel.mer": "МСШ (Металічність—Світність—Шорсткість)",
	"menu.texture.pbr_channel.mer_subsurface": "Підповерхневе МСШ",
	"menu.collection.export_project": "Експортувати проєкт",
	"menu.collection.export_as": "Експортувати як «%0»",
	"menu.panel.enable": "Увімкнути",
	"menu.panel.move_to": "Перемістити до",
	"menu.panel.move_to.left_bar": "Лівої бокової панелі",
	"menu.panel.move_to.right_bar": "Правої бокової панелі",
	"menu.panel.move_to.top": "Верху",
	"menu.panel.move_to.bottom": "Низу",
	"menu.panel.move_to.float": "Сплавне",
	"menu.panel.move_to.hidden": "Сховати",
	"menu.panel.fold": "Згорнути",
	"menu.mirror_painting.texture_center": "Походження",
	"menu.mirror_modeling.mirror_uv": "Віддзеркалити UV",
	"menu.animation_onion_skin.frames": "Кадри",
	"menu.animation_onion_skin.select": "Вибрати",
	"menu.animation_onion_skin.previous": "Попередні",
	"menu.animation_onion_skin.next": "Наступні",
	"menu.animation_onion_skin.previous_next": "Попередні + Наступні",
	"menu.animation_onion_skin.count": "Кількість",
	"menu.animation_onion_skin.interval": "Інтервал",
	"menu.animation_onion_skin_selective": "Виділені фантом кадри",
	"menu.animation_onion_skin_selective.desc": "Показувати лише фантом кадри для виділеної частини моделі",
	"edit.loop_cut.unit": "Одиниця",
	"edit.loop_cut.unit.size_units": "Одиниці розміру",
	"edit.loop_cut.unit.percent": "Відсоток",
	"edit.extrude_mesh_selection.direction": "Напрямок",
	"edit.extrude_mesh_selection.direction.outwards": "Назовні",
	"edit.extrude_mesh_selection.direction.average": "Середній",
	"edit.extrude_mesh_selection.even_extend": "Рівномірне розширення",
	"edit.vertex_snap.align": "Вирівняти",
	"edit.vertex_snap.align.longest": "Найдовша вісь",
	"edit.vertex_snap.align.direction": "Напрямок від точки оберту",
	"edit.vertex_snap.align.align_axis": "Вісь %0",
	"edit.vertex_snap.ignore_axis": "Ігнорувати вісь",
	"codec.common.format": "Формат",
	"codec.image.quality": "Якість",
	"panel.collections": "Колекції",
	"modifier_actions.always": "Завжди ввімкнено",
	"modifier_actions.unless": "Хіба що %0",
	"settings.undo_selections": "Скасувати виділення",
	"settings.undo_selections.desc": "Відстежувати зміни виділень як крок в історії скасувань",
	"action.focus_on_selection.zoom": "Підігнати масштаб",
	"display.reference.tooting": "Показ посилання",
	"settings.selection_tolerance": "Толерантність виділення",
	"settings.selection_tolerance.desc": "Розмір області, яку можна натиснути, щоб виділити ребро або вершину",
	"action.delete.keep_vertices": "Зберігати ребра/вершини",
	"menu.mesh": "Сітка",
	"dialog.material_config.subsurface": "Підповерхневе розсіювання",
	"dialog.material_config.subsurface_enabled.desc": "Використовувати альфа-канал мапи МСШ для підповерхневого розсіювання",
	"settings.pick_combined_color": "Вибрати зведений колір",
	"settings.pick_combined_color.desc": "Вибирати зведений колір з усіх шарів у відповідному пікселі замість кольору з активного шару",
	"action.split_rgb_into_layers": "Розділити канали RGB на шари",
	"action.split_rgb_into_layers.desc": "Розділяти текстуру на додаткові шари, по одному для кожного каналу RGB.",
	"dialog.project.java_block_version": "Форматування версії",
	"data.spline_mesh": "Сплайн",
	"data.billboard": "Білборд",
	"data.armature": "Скелет",
	"data.armature_bone": "Кістка скелету",
	"generic.reload": "Перезавантажити",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Обрати кістку",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Пропустити",
	"dialog.add_spline.shape": "Форма",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Коло",
	"dialog.add_spline.diameter": "Діаметр",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Довжина",
	"dialog.add_spline.width": "Ширина",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Мінімізувати",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Фон",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Свій колір",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Радіус сплайну",
	"action.slider_spline_radius.desc": "Змінити радіус сплайну",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Пензель ваг",
	"action.weight_brush.desc": "Зафарбувати ваги вершин на мешах для деформацій скелету",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Оновити позу",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Додати власну позу",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Додати сплайн",
	"action.add_spline.desc": "Додає новий сплайн",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Додати скелет",
	"action.add_armature.desc": "Додає скелет, який дозволяє деформувати меш за допомогою анімації",
	"action.add_armature_bone": "Додати кістку скелету",
	"action.add_armature_bone.desc": "Додає кістку до скелету",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Геометрія",
	"action.spline_render_mode.mesh": "Меш",
	"action.spline_render_mode.path": "Шлях",
	"action.spline_render_mode.desc": "Яку геометрію відображає цей сплайн",
	"action.spline_uv_mode": "Стиль UV",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Рівномірний",
	"action.spline_uv_mode.per_segment": "Посегментно",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Встановити вагу вершин",
	"action.set_vertex_weights.desc": "Встановити ваги вибраних вершин на певне значення на певній кістці скелету",
	"action.calculate_vertex_weights": "Розрахувати ваги вершин",
	"action.calculate_vertex_weights.desc": "Автоматично призначити ваги вершинам спираючись на позиціях кісток",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Вага вершин",
	"action.view_mode.weighted_bone_colors": "Кольори кісток вершин",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Карта нормалей",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Зберегти як",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Затінення",
	"mesh.shading.flat": "Пласко",
	"mesh.shading.smooth": "Плавно",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "З'єднано",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Додати як шар",
	"message.load_images.category.add_to_project": "Додати до проєкту",
	"message.load_images.category.new_project": "Новий проєкт",
	"message.load_palette.title": "Завантажити палітру",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Вага",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Пласко",
	"spline.shading.smooth": "Плавно",
	"spline.shading": "Затінення",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Встановити",
	"action.weight_brush_blend_mode.add": "Додати",
	"action.apply_texture_to_elements": "Застосувати текстуру до елементів",
	"action.apply_texture_to_elements.desc": "Застосувати обрану текстуру до обраних елементів",
	"menu.panel.reset_size": "Зкинути розмір",
	"action.import_layer": "Імпортувати шар",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Відкрити фаїл",
	"layout.version": "Версія",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Звичайний Bedrock формат",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Невідомий проєкт",
	"message.recover_backup.discard_others": "Відкинути всі інші",
	"message.unsupported_file_extension.title": "Формат файлу не підтримується",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Редагувати ромір UV",
	"dialog.edit_uv_size.target": "Ціль",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Текстури",
	"dialog.adjust_brightness_contrast.brightness": "Яскравість",
	"dialog.adjust_brightness_contrast.contrast": "Контраст",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Режим",
	"dialog.adjust_opacity.mode.multiply": "Множити",
	"dialog.adjust_opacity.mode.set": "Встановити",
	"dialog.bedrock_bounding_box.type": "Тип",
	"dialog.bedrock_bounding_box.type.collision_box": "Зіткнення",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Гітбокс",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "ID плагінів",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Показ UV граней",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Тільки обрані грані",
	"settings.display_uv.selected_elements": "Всі грані обраного елементу",
	"settings.display_uv.all_elements": "Всі грані всіх елементів",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Масштабувати перегляд",
	"keybind.uv_editor_scroll_zoom": "Масштабувати UV/2D редактор",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Меню",
	"action.copy_installed_plugins": "Копіювати встановленні плагіни",
	"action.copy_installed_plugins.desc": "Генерувати та копіювати перелік всіх встановлених плагінів",
	"action.install_plugins_from_list": "Встановити плагіни з переліку",
	"action.install_plugins_from_list.desc": "Встановити плагіни за переліком їх ID",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Показати всі елементи",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Дзеркальне анімування",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "Формат файлу",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}